let scriptExecuted = false;
function BlsOptimize() {
  document.querySelectorAll("script[type='lazyScriptScroll']").forEach((el) => {
    if (!scriptExecuted) {
      eval(el.innerHTML);
      scriptExecuted = true;
    }
  });
}

("use strict");
const global = {
  announcementBar: "announcement-bar",
  overlay: ".bls__overlay",
  header: "header",
  mobile_stickybar: "shopify-section-mobile-stickybar",
};

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

let blsBackTopEl;
function backToTop() {
  // Resolve the progress element once; when it's absent, skip the layout reads
  // entirely so pages without the indicator don't force a reflow per scroll frame.
  if (blsBackTopEl === undefined) {
    blsBackTopEl = document.getElementById("bls__back-top") || null;
  }
  if (!blsBackTopEl) return;
  var winScroll = window.pageYOffset || document.documentElement.scrollTop;
  var height =
    document.documentElement.scrollHeight -
    document.documentElement.clientHeight;
  var scrolled = height > 0 ? (winScroll / height) * 100 : 0;
  blsBackTopEl.style.height = scrolled + "%";
}

let blsStickyHeaderH = null;
function blsComputeStickyHeaderH() {
  var headerbar = document.getElementById("announcement-bar")?.clientHeight || 0;
  var headertopbar =
    document.getElementById("shopify-section-top-bar")?.clientHeight || 0;
  var headerpage = document.getElementById("page-header")?.clientHeight || 0;
  blsStickyHeaderH = headerbar + headertopbar + headerpage + 50;
}
function mobileStickyBar() {
  var stickybar = document.querySelector(".bls__mobile-stickybar");
  if (!stickybar) {
    return;
  }
  // Header height is constant during scroll; compute once and cache it to avoid
  // a forced reflow (clientHeight read) on every scroll event. Recomputed on resize.
  if (blsStickyHeaderH === null) {
    blsComputeStickyHeaderH();
  }
  var currentScroll = window.pageYOffset;
  if (currentScroll > blsStickyHeaderH) {
    stickybar.classList.remove("d-none");
  } else {
    stickybar.classList.add("d-none");
  }
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

// function initComparisons() {
//   var x, i;
//   x = document.getElementsByClassName("img-comp-overlay");
//   for (i = 0; i < x.length; i++) {
//     compareImages(x[i]);
//   }
//   function compareImages(img) {
//     var slider,
//       img,
//       clicked = 0,
//       w,
//       h;
//     w = img.offsetWidth;
//     h = img.offsetHeight;
//     const icc = img.closest(".img-comp-container");
//     if (icc) {
//       slider = icc.querySelector(".image-comparison__button");
//     }
//     if (slider) {
//       slider.addEventListener("touchstart", slideReady);
//       slider.addEventListener("mousedown", slideReady);
//     }
//     window.addEventListener("mouseup", slideFinish);
//     window.addEventListener("touchend", slideFinish);
//     function slideReady(e) {
//       e.preventDefault();
//       clicked = 1;
//       window.addEventListener("mousemove", slideMove);
//       window.addEventListener("touchmove", slideMove);
//     }
//     function slideFinish() {
//       clicked = 0;
//     }
//     function slideMove(e) {
//       var pos;
//       if (clicked == 0) return false;
//       pos = getCursorPos(e);
//       if (pos < 0) pos = 0;
//       if (pos > w) pos = w;
//       slide(pos);
//     }
//     function getCursorPos(e) {
//       var a,
//         x = 0;
//       e = e.changedTouches ? e.changedTouches[0] : e;
//       a = img.getBoundingClientRect();
//       x = e.pageX - a.left;
//       x = x - window.pageXOffset;

//       return x;
//     }
//     function slide(x) {
//       if (slider) {
//         var x_ps = x + slider.offsetWidth / 2 + 10;
//         var percent = (x_ps / w) * 100;
//         if (percent >= 100 - ((slider.offsetWidth / 2 + 10) / w) * 100) {
//           percent = 100 - ((slider.offsetWidth / 2 + 10) / w) * 100;
//         }
//       }

//       img
//         .closest(".img-comp-container")
//         .setAttribute(
//           "style",
//           "--percent: " + percent.toFixed(4) + "%;--height: " + h + "px "
//         );
//     }
//   }
// }
// initComparisons();

const slideAnime = (() => {
  let isAnimating = false;
  return (setOptions) => {
    const defaultOptions = {
      target: false,
      animeType: "slideToggle",
      duration: 400,
      easing: "ease",
      isDisplayStyle: "block",
    };
    const options = Object.assign({}, defaultOptions, setOptions);
    const target = options.target;
    if (!target) {
      return;
    }
    if (isAnimating) {
      return;
    }
    isAnimating = true;
    let animeType = options.animeType;
    const styles = getComputedStyle(target);
    if (animeType === "slideToggle") {
      animeType = styles.display === "none" ? "slideDown" : "slideUp";
    }
    if (
      (animeType === "slideUp" && styles.display === "none") ||
      (animeType === "slideDown" && styles.display !== "none") ||
      (animeType !== "slideUp" && animeType !== "slideDown")
    ) {
      isAnimating = false;
      return false;
    }
    target.style.overflow = "hidden";
    const duration = options.duration;
    const easing = options.easing;
    const isDisplayStyle = options.isDisplayStyle;
    if (animeType === "slideDown") {
      target.style.display = isDisplayStyle;
    }
    const heightVal = {
      height: target.getBoundingClientRect().height + "px",
      marginTop: styles.marginTop,
      marginBottom: styles.marginBottom,
      paddingTop: styles.paddingTop,
      paddingBottom: styles.paddingBottom,
    };
    Object.keys(heightVal).forEach((key) => {
      if (parseFloat(heightVal[key]) === 0) {
        delete heightVal[key];
      }
    });
    if (Object.keys(heightVal).length === 0) {
      isAnimating = false;
      return false;
    }
    let slideAnime;
    if (animeType === "slideDown") {
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = 0;
      });
      slideAnime = target.animate(heightVal, {
        duration: duration,
        easing: easing,
      });
    } else if (animeType === "slideUp") {
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = heightVal[key];
        heightVal[key] = 0;
      });
      slideAnime = target.animate(heightVal, {
        duration: duration,
        easing: easing,
      });
    }
    slideAnime.finished.then(() => {
      target.style.overflow = "";
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = "";
      });
      if (animeType === "slideUp") {
        target.style.display = "none";
      }
      isAnimating = false;
    });
  };
})();

const slideAnimeHide = (() => {
  let isAnimating = false;

  return (setOptions) => {
    const defaultOptions = {
      target: false,
      animeType: "slideToggle",
      duration: 250,
      easing: "ease",
      isDisplayStyle: "block",
      parent: false,
    };
    const options = Object.assign({}, defaultOptions, setOptions);
    const target = options.target;
    const parent = options.parent;
    if (!target) {
      return;
    }

    if (isAnimating) {
      return;
    }
    isAnimating = true;
    parent.classList?.toggle("opened");

    let animeType = options.animeType;
    const styles = getComputedStyle(target);
    if (animeType === "slideToggle") {
      animeType = styles.display === "none" ? "slideDown" : "slideUp";
    }
    if (
      (animeType === "slideUp" && styles.display === "none") ||
      (animeType === "slideDown" && styles.display !== "none") ||
      (animeType !== "slideUp" && animeType !== "slideDown")
    ) {
      isAnimating = false;
      return false;
    }
    target.style.overflow = "hidden";
    const duration = options.duration;
    const easing = options.easing;
    const isDisplayStyle = options.isDisplayStyle;

    if (animeType === "slideDown") {
      target.style.display = isDisplayStyle;
    }
    const heightVal = {
      height: target.getBoundingClientRect().height + "px",
      marginTop: styles.marginTop,
      marginBottom: styles.marginBottom,
      paddingTop: styles.paddingTop,
      paddingBottom: styles.paddingBottom,
    };

    Object.keys(heightVal).forEach((key) => {
      if (parseFloat(heightVal[key]) === 0) {
        delete heightVal[key];
      }
    });
    if (Object.keys(heightVal).length === 0) {
      isAnimating = false;
      return false;
    }
    let slideAnime;
    if (animeType === "slideDown") {
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = 0;
      });
      slideAnime = target.animate(heightVal, {
        duration: duration,
        easing: easing,
      });
    } else if (animeType === "slideUp") {
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = heightVal[key];
        heightVal[key] = 0;
      });
      slideAnime = target.animate(heightVal, {
        duration: duration,
        easing: easing,
      });
    }
    slideAnime.finished.then(() => {
      target.style.overflow = "";
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = "";
      });
      if (animeType === "slideUp") {
        target.style.display = "none";
      }
      isAnimating = false;
    });
  };
})();

var BlsEventShopify = (function () {
  return {
    init: function () {
      this.setupEventListeners();
      Shopify.eventCountDownTimer();
      Shopify.eventFlashingBrowseTab();
    },
    setupEventListeners: function () {
      let blsScrollTicking = false;
      window.addEventListener(
        "scroll",
        () => {
          // Coalesce scroll work into one rAF per frame and listen passively so
          // the layout reads in backToTop()/mobileStickyBar() can't jank scroll.
          if (blsScrollTicking) return;
          blsScrollTicking = true;
          window.requestAnimationFrame(() => {
            blsScrollTicking = false;
            backToTop();
            mobileStickyBar();
          });
        },
        { passive: true }
      );
      window.addEventListener("resize", blsComputeStickyHeaderH);

      document
        .querySelectorAll(".collection-infinite-scroll a")
        .forEach((showMore) => {
          showMore.addEventListener(
            "click",
            (e) => {
              for (var item of document.querySelectorAll(
                ".collection-list__item.grid__item"
              )) {
                item.classList.remove("d-none");
              }
              showMore.parentElement.remove();
            },
            false
          );
        });

      const footer_block = document.querySelectorAll(
        ".bls__footer_block-title"
      );
      footer_block.forEach((footer) => {
        footer.addEventListener("click", (e) => {
          const target = e.currentTarget;
          const parent = target.parentElement;
          const footerContent = parent.querySelector(
            ".bls__footer_block-content"
          );
          slideAnime({
            target: footerContent,
            animeType: "slideToggle",
          });
          const footer_block = target.closest(".bls__footer_block");
          if (!footer_block.classList.contains("active")) {
            footer_block.classList.add("active");
          } else {
            footer_block.classList.remove("active");
          }
        });
      });

      const mobile_stickybar = document.getElementById(global.mobile_stickybar);
      const ft = document.querySelector("footer");
      if (mobile_stickybar && ft) {
        ft.classList.add("enable_menu-bottom");
      }

      const cookie_bar = document.getElementById("bls_cookie");
      if (cookie_bar) {
        if (!getCookie("cookie_bar")) {
          cookie_bar.classList.remove("d-none");
        }
        document
          .querySelectorAll("#bls_cookie .cookie-dismiss")
          .forEach((closeCookie) => {
            closeCookie.addEventListener(
              "click",
              (e) => {
                e.preventDefault();
                const target = e.currentTarget;
                target.closest("#bls_cookie").remove();
                setCookie("cookie_bar", "dismiss", 30);
              },
              false
            );
          });
      }

      const announcementBar = document.getElementById(global.announcementBar);
      if (announcementBar && typeof Swiper !== "undefined") {
        const swc = announcementBar.querySelector(".swiper-announcementBar");
        if (swc) {
          swc.style.maxHeight = announcementBar.offsetHeight + "px";
          var swiper = new Swiper(".swiper-announcementBar", {
            loop: true,
            slidesPerView: 1,
            direction: "vertical",
            autoplay: {
              delay: 3000,
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          });
        }
        const cds = announcementBar.querySelectorAll(
          ".countdown-announcementBar"
        );
        cds.forEach((cd) => {
          const cddl = cd?.dataset.blockDeadline;
          const dateParts = cddl.split("-");
          const isoDate =
            dateParts[2] +
            "-" +
            dateParts[0].padStart(2, "0") +
            "-" +
            dateParts[1].padStart(2, "0") +
            "T00:00:00Z";
          if (cddl && Date.parse(isoDate)) {
            const deadline = new Date(isoDate);
            const calculateTimeLeft = () => {
              const difference = +deadline - +new Date();
              let timeLeft = {};
              if (difference > 0) {
                timeLeft = {
                  days_announcementBar: Math.floor(
                    difference / (1000 * 60 * 60 * 24)
                  ),
                  hours_announcementBar: Math.floor(
                    (difference / (1000 * 60 * 60)) % 24
                  ),
                  minutes_announcementBar: Math.floor(
                    (difference / 1000 / 60) % 60
                  ),
                  seconds_announcementBar: Math.floor((difference / 1000) % 60),
                };
              }
              return timeLeft;
            };
            const updateCountdown = () => {
              const timeLeft = calculateTimeLeft();
              Object.entries(timeLeft).forEach(([key, value]) => {
                cd.querySelector("." + key).innerHTML = value;
              });
            };

            setInterval(updateCountdown, 1000);
          }
        });
        if (getCookie("announcement_bar")) {
          announcementBar.classList.add("d-none");
        }
        document
          .querySelectorAll("#announcement-bar .announcement-close")
          .forEach((closeAnnouncement) => {
            closeAnnouncement.addEventListener(
              "click",
              (e) => {
                e.preventDefault();
                const target = e.currentTarget;
                target.closest("#announcement-bar").remove();
                setCookie("announcement_bar", 1, 1);
              },
              false
            );
          });
      }
      const conditions = document.getElementById("product_conditions_form");
      if (conditions) {
        conditions.addEventListener("change", (event) => {
          const bpb = document.querySelector(".bls__payment-button");
          if (bpb) {
            if (event.currentTarget.checked) {
              bpb.classList.remove("disabled");
            } else {
              bpb.classList.add("disabled");
            }
          }
        });
      }

      document.querySelectorAll(global.overlay).forEach((event) => {
        event.addEventListener(
          "click",
          (e) => {
            const target = e.currentTarget;
            target.classList.add("d-none-overlay");
            document.documentElement.classList.remove("hside_opened");
            document.documentElement.classList.remove("vetical-overlay");
            document.documentElement.classList.remove("open-search");
            const searchForm = document.getElementById("search-form");
            if (searchForm) {
              searchForm.classList.remove("bls__opend-popup-header");
            }
            for (var item of document.querySelectorAll(".bls__opend-popup")) {
              item.classList.remove("bls__opend-popup");
            }
            const btn = document.querySelector(".btn-filter");
            if (btn && btn.classList.contains("actived")) {
              btn.classList.remove("actived");
            }
            for (var item of document.querySelectorAll(".bls__addon")) {
              item.classList.remove("is-open");
            }
            for (var item of document.querySelectorAll(
              ".bls-minicart-wrapper"
            )) {
              item.classList.remove("addons-open");
            }
            for (var item of document.querySelectorAll(".vertical-menu")) {
              item.classList.remove("open");
            }
            document.documentElement.classList.remove("nav-open");
            if (typeof MobileNavPortal !== "undefined") {
              MobileNavPortal.close();
            }
          },
          false
        );
      });

      document.querySelectorAll(".bls__terms-conditions a").forEach((event) => {
        event.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            const content = document.getElementById("popup-terms-conditions");
            if (!content) return;
            const text = content.getAttribute("data-text");
            var promotion = EasyDialogBox.create(
              "popup-terms-conditions",
              "dlg dlg-disable-footer dlg-disable-drag",
              text,
              content.innerHTML
            );
            promotion.onClose = promotion.destroy;
            promotion.show(300);
          },
          false
        );
      });
    },
  };
})();
BlsEventShopify.init();
//task custom
// var BlsCustomSlideShow = (function () {
//   return {
//     init: function () {
//       this.CustomInnerMenu();
//     },
//     CustomInnerMenu: function () {
//       const article = document.querySelector(".verticalmenu-html");
//       const menuSlide = document.querySelectorAll(".menu-slide");
//       if (article) {
//         const menuHtml = article.innerHTML;
//         if (menuSlide) {
//           menuSlide.forEach((menu) => {
//             menu.innerHTML = menuHtml;
//             menu
//               .closest(".bls-wrapper")
//               .querySelector(".bls_vertical_menu .title-menu-dropdown")
//               .classList.add("none-pointer");
//           });
//         }
//       }
//       if (menuSlide === null) return;
//       if (article) {
//         let width = screen.width;
//         const limitItemShow = article.dataset.limitshowitem;
//         const lenghtLi = document.querySelectorAll(
//           ".menu-slide .level0"
//         ).length;
//         if (width > 1199) {
//           if (lenghtLi > limitItemShow) {
//             var lineItem = Array.from(
//               document.querySelectorAll(".menu-slide .level0")
//             );
//             lineItem.forEach((element, index) => {
//               if (index > limitItemShow - 1) {
//                 const item = lineItem[index];
//                 if (item.classList.contains("expand-menu-link")) {
//                   return;
//                 }
//                 item.classList.add("orther-link");
//                 item.style.display = "none";
//               }
//             });
//             document.querySelector(
//               ".menu-slide .expand-menu-link"
//             ).style.display = "block";
//             document
//               .querySelector(".menu-slide .expand-menu-link a")
//               .addEventListener(
//                 "click",
//                 (e) => {
//                   e.preventDefault();
//                   const target = e.currentTarget;
//                   const parent = target.parentElement;
//                   if (!parent.classList.contains("expanding")) {
//                     parent.classList.add("expanding");
//                     parent.querySelector("a").innerHTML =
//                       window.menuStrings?.hideMenus;
//                     for (var item of document.querySelectorAll(
//                       ".menu-slide .level0.orther-link"
//                     )) {
//                       slideAnime({
//                         target: item,
//                         animeType: "slideDown",
//                       });
//                     }
//                   } else {
//                     parent.classList.remove("expanding");
//                     parent.querySelector("a").innerHTML =
//                       window.menuStrings?.moreMenus;
//                     for (var item of document.querySelectorAll(
//                       ".menu-slide .level0.orther-link"
//                     )) {
//                       slideAnime({
//                         target: item,
//                         animeType: "slideUp",
//                       });
//                     }
//                   }
//                 },
//                 false
//               );
//           } else {
//             if (document.querySelector(".slideshow-custom .expand-menu-link")) {
//               document.querySelector(
//                 ".slideshow-custom .expand-menu-link"
//               ).style.display = "none";
//             }
//           }
//         }
//       }
//     },
//   };
// })();
// BlsCustomSlideShow.init();

let newParser = new DOMParser();
var BlsSettingsSwiper = (function () {
  return {
    init: function () {
      this.BlsSettingsCarousel();
    },
    BlsSettingsCarousel: function () {
      if (typeof Swiper === "undefined") return;
      document.querySelectorAll(".bls__swiper").forEach((element) => {
        this.BlsCarousel(element);
      });
    },
    BlsCarousel: function (e) {
      if (typeof Swiper === "undefined") return;
      var sliderGlobal;
      var autoplaying = e?.dataset.autoplay === "true";
      var loop = e?.dataset.loop === "true";
      var dataSlideshow = e?.dataset.slideshow ? e?.dataset.slideshow : 0;
      var itemDesktop = e?.dataset.desktop ? e?.dataset.desktop : 4;
      var itemTablet = e?.dataset.tablet ? e?.dataset.tablet : 2;
      var itemMobile = e?.dataset.mobile ? e?.dataset.mobile : 1;
      var autoplaySpeed = e?.dataset.autoplaySpeed
        ? e?.dataset.autoplaySpeed
        : 3000;
      var speed = e?.dataset.speed ? e?.dataset.speed : 400;
      var effect = e?.dataset.effect ? e?.dataset.effect : "slide";
      var sectionId = e?.dataset.sectionId;
      var row = e?.dataset.row ? e?.dataset.row : 1;
      var width = window.innerWidth;
      var spacing = e?.dataset.spacing ? e?.dataset.spacing : 0;
      var progressbar = e?.dataset.paginationProgressbar === "true";
      var autoItem = e?.dataset.itemMobile === "true";
      var centeredSlides = e?.dataset.centeredSlides === "true";

      spacing = Number(spacing);
      autoplaySpeed = Number(autoplaySpeed);
      speed = Number(speed);
      if (width <= 767) {
        if (spacing >= 15) {
          spacing = 15;
        }
      } else if (width <= 1199) {
        if (spacing >= 30) {
          spacing = 30;
        }
      }
      if (autoplaying) {
        var autoplaying = { delay: autoplaySpeed };
      }

      // ensure global registry for instances
      window.blsSwiperInstances = window.blsSwiperInstances || {};
      var selector = "#bls__swiper-" + sectionId;
      var containerEl = document.querySelector(selector);
      if (!sectionId || !containerEl) return;
      // destroy any existing swiper attached to the container to avoid duplicates
      if (containerEl && containerEl.swiper) {
        try { containerEl.swiper.destroy(true, true); } catch (err) { }
      }
      if (window.blsSwiperInstances[sectionId]) {
        try { window.blsSwiperInstances[sectionId].destroy(true, true); } catch (err) { }
        delete window.blsSwiperInstances[sectionId];
      }

      sliderGlobal = new Swiper("#bls__swiper-" + sectionId, {
        slidesPerView: autoItem ? "auto" : itemMobile,
        spaceBetween: spacing,
        autoplay: autoplaying,
        loop: loop,
        effect: effect,
        speed: speed,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        centeredSlides: centeredSlides,
        centeredSlidesBounds: true,
        grid: {
          rows: row,
          fill: "row",
        },
        navigation: {
          nextEl: e.querySelector(".swiper-button-next"),
          prevEl: e.querySelector(".swiper-button-prev"),
        },
        pagination: {
          clickable: true,
          el: e.querySelector(".swiper-pagination"),
          type: progressbar ? "progressbar" : "bullets",
        },
        breakpoints: {
          0: {
            slidesPerView: itemMobile,
          },
          576: {
            slidesPerView: itemTablet,
          },
          1200: {
            slidesPerView: itemDesktop,
            centeredSlides: centeredSlides,
            centeredSlidesBounds: true,
          },
        },
      });
      // store instance for potential later destroy
      try {
        if (sliderGlobal) {
          window.blsSwiperInstances[sectionId] = sliderGlobal;
          if (containerEl) containerEl.swiper = sliderGlobal;
        }
      } catch (e) { }
      // ensure swiper renders correctly after dynamic DOM changes
      try {
        sliderGlobal && typeof sliderGlobal.update === 'function' && sliderGlobal.update();
        if (sliderGlobal && sliderGlobal.pagination) {
          typeof sliderGlobal.pagination.render === 'function' && sliderGlobal.pagination.render();
          typeof sliderGlobal.pagination.update === 'function' && sliderGlobal.pagination.update();
        }
      } catch (e) { }
      if (dataSlideshow) {
        sliderGlobal.on("slideChange", function () {
          e.querySelectorAll(".video-slider").forEach((video) => {
            var dataVideo = video.dataset.video;
            var dataPoster = video.dataset.poster;
            video.innerHTML = `
              <video playsinline="true" loop="loop" muted="muted" autoplay="autoplay" preload="metadata"
                poster="${dataPoster}">
                <source
                  src="${dataVideo}"
                  type="video/mp4">
              </video>
              `;
          });
        });
      }
    },
  };
})();
// Initialise each matched element only when it is about to enter the viewport.
// Above-the-fold carousels intersect immediately and init on first frame;
// below-the-fold ones defer their init off the critical path to cut TBT.
function blsLazyInitOnView(selector, callback, rootMargin) {
  var elements = document.querySelectorAll(selector);
  if (!elements.length) return;
  if (!("IntersectionObserver" in window)) {
    elements.forEach(function (el) {
      callback(el);
    });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          obs.unobserve(entry.target);
          callback(entry.target);
        }
      });
    },
    { rootMargin: rootMargin || "600px 0px" }
  );
  elements.forEach(function (el) {
    // Above-the-fold carousels (e.g. the hero slideshow) init synchronously so
    // they never shift layout while the async observer callback is still pending.
    // Below-the-fold carousels defer their init off the critical path.
    var rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      callback(el);
    } else {
      observer.observe(el);
    }
  });
}

if (typeof Swiper !== "undefined") {
  blsLazyInitOnView(".bls__swiper", function (el) {
    BlsSettingsSwiper.BlsCarousel(el);
  });
}

BlsSettingsSwiperTestimonial = (function () {
  return {
    init: function () {
      this.BlsSettingsCarouselTestimonial();
    },
    BlsSettingsCarouselTestimonial: function () {
      if (typeof Swiper === "undefined") return;
      document.querySelectorAll(".bls__testimonial").forEach((element) => {
        this.BlsCarouselTestimonial(element);
      });
    },
    BlsCarouselTestimonial: function (e) {
      if (typeof Swiper === "undefined") return;
      var autoplaying = e?.dataset.autoplay === "true";
      var loop = e?.dataset.loop === "true";
      var itemDesktop = e?.dataset.desktop ? e?.dataset.desktop : 4;
      var itemTablet = e?.dataset.tablet ? e?.dataset.tablet : 2;
      var itemMobile = e?.dataset.mobile ? e?.dataset.mobile : 1;
      var sectionId = e?.dataset.sectionId;
      var width = window.innerWidth;
      var showThumb = e?.dataset.thumb === "true";
      var spacing = e?.dataset.spacing ? e?.dataset.spacing : 0;
      spacing = Number(spacing);
      if (width <= 767) {
        if (spacing >= 15) {
          spacing = 15;
        }
      } else if (width <= 1199) {
        if (spacing >= 30) {
          spacing = 30;
        }
      }
      if (showThumb) {
        new Swiper("#bls__testimonial-" + sectionId, {
          slidesPerView: itemMobile,
          spaceBetween: spacing,
          autoplay: autoplaying,
          loop: loop,
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
          navigation: {
            nextEl: e.querySelector(".swiper-button-next"),
            prevEl: e.querySelector(".swiper-button-prev"),
          },
          pagination: {
            clickable: true,
            el: e.querySelector(".swiper-pagination"),
          },
          breakpoints: {
            768: {
              slidesPerView: itemTablet,
            },
            1200: {
              slidesPerView: itemDesktop,
            },
          },
          thumbs: {
            swiper: {
              el: `.testimonial-thumb-${sectionId}`,
              multipleActiveThumbs: true,
              spaceBetween: 10,
              slidesPerView: "auto",
              freeMode: true,
              centerInsufficientSlides: true,
              watchSlidesProgress: true,
            },
          },
        });
      } else {
        new Swiper("#bls__testimonial-" + sectionId, {
          slidesPerView: itemMobile,
          spaceBetween: spacing,
          autoplay: autoplaying,
          loop: loop,
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
          navigation: {
            nextEl: e.querySelector(".swiper-button-next"),
            prevEl: e.querySelector(".swiper-button-prev"),
          },
          pagination: {
            clickable: true,
            el: e.querySelector(".swiper-pagination"),
          },
          breakpoints: {
            768: {
              slidesPerView: itemTablet,
            },
            1200: {
              slidesPerView: itemDesktop,
            },
          },
        });
      }
    },
  };
})();
if (typeof Swiper !== "undefined") {
  blsLazyInitOnView(".bls__testimonial", function (el) {
    BlsSettingsSwiperTestimonial.BlsCarouselTestimonial(el);
  });
}

var BlsAddMetatagScale = (function () {
  return {
    init: function () {
      this.addMeta();
    },
    addMeta: function () {
      const body = document.querySelector("body");
      const metaTag = document.querySelector('meta[name="viewport"]');
      const currentContent = metaTag.getAttribute("content");
      const updatedContent = currentContent + ", maximum-scale=1";
      body.addEventListener("touchstart", function () {
        metaTag.setAttribute("content", updatedContent);
      });
    },
  };
})();
BlsAddMetatagScale.init();

var BlsToggle = (function () {
  return {
    init: function () {
      this.initToggle(),
        this.backToTop(),
        this.initToggleLookbook(),
        this.slideAnimeFaqImage();
    },
    initToggle: function () {
      var faq_parent = ".bls__page-faq-items .bls__page-faq-title";
      document.querySelectorAll(faq_parent).forEach((item) => {
        item.addEventListener("click", (e) => {
          e.preventDefault();
          const target = e.currentTarget;
          const parent = target.parentElement;
          const faqContent = parent.querySelector(".bls__page-faq-content");
          slideAnime({
            target: faqContent,
            animeType: "slideToggle",
          });
          if (item.closest(".bls-toggle").classList.contains("active")) {
            item.closest(".bls-toggle").classList.remove("active");
          } else {
            item.closest(".bls-toggle").classList.add("active");
          }
        });
      });
    },
    backToTop: function () {
      const b = document.querySelector(".back-top");
      if (b) {
        document.addEventListener(
          "scroll",
          () => {
            if (window.scrollY > 400) {
              b.classList.add("show");
            } else {
              b.classList.remove("show");
            }
          },
          { passive: true }
        );
        b.addEventListener("click", () => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        });
      }
    },
    initToggleLookbook: function () {
      document.body.addEventListener("click", (evt) => {
        const target = evt.target;
        if (
          !target.closest(".bls__product-item") &&
          target !=
          document.querySelector(
            ".bls__product-item.active .lookbook__popup-items"
          )
        ) {
          const lookbook_items =
            document.querySelectorAll(".bls__product-item");
          lookbook_items.forEach((items) => {
            items.classList.remove(
              "active",
              "top",
              "bottom",
              "left",
              "right",
              "center"
            );
          });
        }
      });
      document.body.addEventListener("click", this.onBodyClick);
      const lookbook = document.querySelectorAll(".lookbook-action");
      lookbook.forEach((action) => {
        action.addEventListener("click", (e) => {
          const target = e.currentTarget;
          const item = target.closest(".bls__product-item");
          const lookbook_item = item.querySelector(".lookbook__popup-items");
          const rect = item.getBoundingClientRect();
          const rect_item = lookbook_item.getBoundingClientRect();
          const item_right = rect_item.right;
          const item_left = rect_item.left;
          let height = window.innerHeight;
          let width = window.innerWidth;
          let pos_l = "center";
          const top = rect.top;
          const lookbook_items =
            document.querySelectorAll(".bls__product-item");
          if (!item.classList.contains("active")) {
            lookbook_items.forEach((items) => {
              items.classList.remove(
                "active",
                "top",
                "bottom",
                "left",
                "right",
                "center"
              );
            });
            item.classList.add("active");
            if (width > 767) {
              if (item_right > width) {
                pos_l = "left";
              } else if (item_left < 0) {
                pos_l = "right";
              }
              if (top > height / 2) {
                item.classList.add("top", pos_l);
              } else {
                item.classList.add("bottom", pos_l);
              }
            } else {
              if (top > height / 2) {
                item.classList.add("top");
              } else {
                item.classList.add("bottom");
              }
              let left = 0;
              if (item_right > width) {
                left = -50 - (item_right - width);
                lookbook_item.style.left = left + "px";
              } else if (item_left < 0) {
                left = -item_left;
                lookbook_item.style.left = left + "px";
              }
            }
          } else {
            item.classList.remove(
              "active",
              "top",
              "bottom",
              "left",
              "right",
              "center"
            );
          }
        });
      });
    },
    slideAnimeFaqImage: function () {
      const section = document.querySelectorAll(".bls__faq-with-image");
      section.forEach((container) => {
        const dataId = container.dataset.id;
        var faq_parent = `.bls__faq-with-image-${dataId} .bls__page-faq-items-image > .bls__page-faq-title`;
        document.querySelectorAll(faq_parent).forEach((item) => {
          item.addEventListener("click", (e) => {
            e.preventDefault();
            const target = e.currentTarget;
            const id_index = target.dataset.image;
            const parent = target.parentElement;
            if (parent.classList.contains("active")) {
              return;
            }

            slideAnimeHide({
              target: document.querySelector(
                `.bls__faq-with-image-${dataId} .bls__page-faq-items-image.active .bls__page-faq-content`
              ),
              animeType: "slideToggle",
            });
            document
              .querySelector(
                `.bls__faq-with-image-${dataId} .bls__page-faq-items-image.active`
              )
              .classList.remove("active");

            const faqContent = parent.querySelector(".bls__page-faq-content");
            slideAnime({
              target: faqContent,
              animeType: "slideToggle",
            });
            if (item.closest(".bls-toggle").classList.contains("active")) {
              item.closest(".bls-toggle").classList.remove("active");
            } else {
              item.closest(".bls-toggle").classList.add("active");
            }
            document
              .querySelector(
                `.bls__faq-with-image-${dataId} .faq-image-item.active`
              )
              .classList.remove("active");
            document
              .querySelector(
                `.bls__faq-with-image-${dataId} .faq-image-item.image-${id_index}`
              )
              .classList.add("active");
          });
        });
      });
    },
  };
})();
BlsToggle.init();

var BlsPopup = (function () {
  return {
    init: function () {
      this.fetchDataNewletter(),
        this.fetchDataPromotion(),
        this.checkFormInfo(),
        this.checkShowMsgStockNotify();
    },
    setCookie: function (cname, exdays, cvalue) {
      const date = new Date();
      date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + date.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie: function (cname) {
      let name = cname + "=";
      let ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    deleteCookie: function (cname) {
      document.cookie = cname + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    },
    fetchDataNewletter: function () {
      const url = `${window.location.pathname}?section_id=newsletter-popup`;
      const _this = this;
      if (window.popup?.newsletterPopup !== false) {
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = newParser.parseFromString(responseText, "text/html");
            const n = html.querySelector("#bls__newsletter-popup");
            if (n) {
              const c = n?.dataset.show;
              const disableMobile = n?.dataset.showMobile === "true";
              if (c === "show-on-all-pages" || c === "show-on-homepage") {
                if (_this.getCookie("bls-newsletter-popup") === "") {
                  var newsletter = EasyDialogBox.create(
                    "newsletterp",
                    `dlg dlg-disable-footer	dlg-disable-drag ${disableMobile ? "dlg-disable-mobile" : ""
                    }`,
                    "",
                    n.innerHTML
                  );
                  newsletter.onClose = newsletter.destroy;
                  newsletter.show(1000);
                  newsletter.onShow = function () {
                    _this.checkNotShowNewletter();
                  };
                }
              }
            }
          })
          .catch((e) => {
            throw e;
          });
      }
    },
    checkNotShowNewletter: function () {
      const _this = this;
      const check = document.getElementById("doNotShow");
      if (check) {
        check.addEventListener("change", (e) => {
          if (e.currentTarget.checked) {
            _this.setCookie("bls-newsletter-popup", 99999, "bls");
          } else {
            _this.deleteCookie("bls-newsletter-popup");
          }
        });
      }
    },
    fetchDataPromotion: function () {
      const _this = this;

      if (!sessionStorage.getItem("promotionPopupShown")) {
        const url = `${window.location.pathname}?section_id=promotion-popup`;
        if (window.popup?.promotionPopup !== false) {
          fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
              const html = newParser.parseFromString(responseText, "text/html");
              const p = html.querySelector("#bls__promotion-popup");
              const s = p?.dataset.show === "true";
              const m = p?.dataset.showMb === "true";
              if (s === true) {
                var promotion = EasyDialogBox.create(
                  "promotionp",
                  `dlg dlg-disable-footer ${m ? "" : "dlg-disable-mobile"
                  } dlg-disable-drag`,
                  "",
                  p.innerHTML
                );
                promotion.onClose = promotion.destroy;

                // Thay vì gọi promotion.show(20000), ta gọi show sau delay 20s
                setTimeout(() => {
                  promotion.show();
                  promotion.onShow = function () {
                    _this.copyPromotion();
                    _this.checkNotShowPromotion();
                  };
                }, 18000); // Delay 20 giây

                sessionStorage.setItem("promotionPopupShown", "true");
              }
            })
            .catch((e) => {
              console.error(e);
            });
        }
      }
    },
    checkNotShowPromotion: function () {
      const _this = this;
      const check = document.querySelector("#doNotShowPromotion");
      if (check) {
        check.addEventListener("change", (e) => {
          if (e.currentTarget.checked) {
            _this.setCookie("bls-promotion-popup", 99999, "bls");
          } else {
            _this.deleteCookie("bls-promotion-popup");
          }
        });
      }
    },
    copyPromotion: function () {
      const cp = document.querySelectorAll(".discount");
      if (cp !== null) {
        cp.forEach((e) => {
          e.addEventListener("click", (el) => {
            el.preventDefault();
            navigator.clipboard.writeText(e?.dataset.code);
            e.classList.add("action-copy");
            setTimeout(() => {
              e.classList.remove("action-copy");
            }, 1500);
          });
        });
      }
    },
    checkFormInfo: function () {
      const _this = this;
      const urlInfo = window.location.href;
      const formInfo = document.querySelector(".form-infor");
      const formErr = document.querySelector(".form-infor-body.noti-error");
      const fi = document.querySelector(".form-infor,.close-form-info");
      const formSuccess = document.querySelector(
        ".form-infor-body.noti-success"
      );
      if (fi) {
        fi.addEventListener("click", (e) => {
          const target = e.currentTarget;
          const closet = target.closest(".form-infor");
          e.preventDefault();
          if (closet.classList.contains("show-noti-form")) {
            closet.classList.remove("show-noti-form");
          }
        });
      }
      if (urlInfo.indexOf("customer_posted=true#newsletter-form-popup") >= 1) {
        formInfo.classList.add("show-noti-form");
        formErr.style.display = "none";
        _this.setCookie("bls-newsletter-popup", 99999, "bls");
        const newURL = location.href.split("?")[0];
        window.history.pushState("object", document.title, newURL);
      }
      if (
        urlInfo.indexOf("contact%5Btags%5D=newsletter&form_type=customer") >= 1
      ) {
        formInfo.classList.add("show-noti-form");
        formSuccess.style.display = "none";
        const newURL = location.href.split("?")[0];
        window.history.pushState("object", document.title, newURL);
      }
      if (urlInfo.indexOf("customer_posted=true") >= 1) {
        formInfo.classList.add("show-noti-form");
        formErr.style.display = "none";
        const newURL = location.href.split("?")[0];
        _this.setCookie("bls-newsletter-popup", 99999, "bls");
        window.history.pushState("object", document.title, newURL);
      }
    },
    checkShowMsgStockNotify: function () {
      const urlInfo = window.location.href;
      const formInfo = document.querySelector(".stock-notify");
      const fi = document.querySelector(
        ".stock-notify,.close-form-stock-notify"
      );
      if (fi) {
        fi.addEventListener("click", (e) => {
          const target = e.currentTarget;
          const closet = target.closest(".stock-notify");
          e.preventDefault();
          if (closet.classList.contains("show-noti-form")) {
            closet.classList.remove("show-noti-form");
          }
        });
      }
      if (urlInfo.indexOf("contact_posted=true#FormStockNotify") > -1) {
        formInfo.classList.add("show-noti-form");
        const newURL = location.href.split("?")[0];
        window.history.pushState("object", document.title, newURL);
      }
    },
  };
})();
BlsPopup.init();

var BlsLazyloadImg = (function () {
  function activateImages(root) {
    const scope = root || document;
    scope.querySelectorAll(".bls-image-js img").forEach((img) => {
      img.classList.add("bls-loaded-image");
      const wrapper = img.closest(".bls-image-js");
      if (wrapper) wrapper.classList.remove("bls-loading-image");
    });
  }

  return {
    init: function (root) {
      if (root) {
        activateImages(root);
        return;
      }
      this.lazyReady();
    },
    activateImages: activateImages,
    lazyReady: function () {
      if (!!window.IntersectionObserver) {
        let observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.width = entry.boundingClientRect.width;
                entry.target.height = entry.boundingClientRect.height;
                entry.target.sizes = `${entry.boundingClientRect.width}px`;
                entry.target.classList.add("bls-loaded-image");
                entry.target
                  .closest(".bls-image-js")
                  .classList.remove("bls-loading-image");
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: "10px" }
        );
        document
          .querySelectorAll(".bls-image-js img:not(.bls-loaded-image)")
          .forEach((img) => {
            observer.observe(img);
          });
      } else {
        activateImages();
      }
    },
  };
})();
BlsLazyloadImg.init();

const rdc = {
  mode: "same-origin",
  credentials: "same-origin",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json",
  },
};
let parser = new DOMParser();
const c = new Map();
const productRecommendationsSection = document.querySelector(
  ".product-recommendations"
);

var BlsReloadEvents = (function () {
  return {
    init: function () {
      this.setupEventListeners();
    },

    setupEventListeners: function () {
      document.addEventListener("shopify:section:load", function (event) {
        var id = event.detail.sectionId;

        var section = event.target.querySelector(
          "[" + "data-id" + '="' + id + '"]'
        );

        if (section != undefined) {
          const { type } = section?.dataset;
          switch (type) {
            case "instagram":
              BlsInstagramShopify.init();
              break;
            case "product_grid":
              BlsProductGridEvents.init();
              BlsProductTabEvents.init();
              BlsColorSwatchesShopify.init();
              break;
            case "product_carousel":
              BlsProductGridEvents.init();
              BlsProductTabEvents.init();
              BlsColorSwatchesShopify.init();
              break;
            case "recently_viewed_products":
              BlsRVProductsShopify.init();
              break;
            case "product_recommendations":
              BlsProductRecommendsEvents.init();
              break;
            case "product_single":
              BlsColorSwatchesShopify.init();
              break;
            case "product_deal":
              BlsColorSwatchesShopify.init();
              BlsCountdownTimer.init();
              break;
            default:
              break;
          }
        }
      });
    },
  };
})();
BlsReloadEvents.init();

var BlsProductGridEvents = (function () {
  return {
    init: function () {
      this.setupEventListeners();
    },

    setupEventListeners: function () {
      const _this = this;
      document.querySelectorAll(".bls__btn-load-more").forEach((el) => {
        el.addEventListener("click", function () {
          const sectionId = this.closest(".bls__grid").dataset.id;
          _this.loadButtonLoadMore(sectionId);
        });
      });
    },

    loadButtonLoadMore: function (sectionId) {
      const defClass = document.querySelector(
        ".bls__load-more_wrap-" + sectionId
      );
      if (defClass != undefined) {
        const { nextUrl, currentPage, totalPages } = defClass?.dataset;
        this.loadMore(defClass, sectionId, nextUrl, currentPage, totalPages);
      }
    },

    loadMore: function (defClass, sectionId, nextUrl, currentPage, totalPages) {
      const grid = document.querySelector("#bls__product-grid-" + sectionId);
      if (grid != undefined) {
        const { id, r, d, to } = grid?.dataset;
        const loadMoreBtn = defClass.querySelector('[type="button"]');
        loadMoreBtn.classList.add("btn-loading");
        let nextPage = parseInt(currentPage) + 1;
        fetch(`${nextUrl}?page=${nextPage}&section_id=${id}`)
          .then((response) => response.text())
          .then((responseText) => {
            const productNodes = parser.parseFromString(
              responseText,
              "text/html"
            );
            const productNodesHtml = productNodes.querySelectorAll(
              `#bls__product-grid-${sectionId} .bls__product-load`
            );
            productNodesHtml.forEach((prodNode) =>
              document
                .getElementById(`bls__product-grid-${sectionId}`)
                .appendChild(prodNode)
            );
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            loadMoreBtn.classList.remove("btn-loading");
            if (nextPage == totalPages) {
              defClass.remove();
            } else {
              defClass.setAttribute("data-current-page", nextPage);
            }
            BlsReloadSpr.init();
            BlsLazyloadImg.init();
          });
      }
    },
  };
})();
BlsProductGridEvents.init();

var BlsProductTabEvents = (function () {
  return {
    init: function () {
      this.setupEventListeners();
      this.setupDropdownStyle();
      document.addEventListener("click", this.closeAllSelect);
    },

    setupEventListeners: function (value) {
      const _this = this;
      const firstDataTab = document.querySelector(".bls__collection-tab-item")
        ?.dataset.id;
      const enableSearch =
        document.querySelector(".bls__section-collection-tab")?.dataset
          .enableSearch === "true";
      let currentArray = this.loadArray(firstDataTab);
      let arrayTab = Array.from(
        document.querySelectorAll(`#${firstDataTab} .bls__product-load`)
      );
      let paginationCurrent = document.querySelector(
        `.pagination #${firstDataTab}`
      );
      let currentPage = 1;
      const itemsPerPage = 9;
      displayResults(currentArray, firstDataTab);
      document.querySelectorAll(".bls__collection-tab").forEach((el) => {
        const tab_item = el.querySelectorAll(".bls__collection-tab-item");
        if (tab_item.length != 0) {
          tab_item.forEach((e) => {
            e.addEventListener("click", function () {
              if (!this.classList.contains("active")) {
                el.querySelectorAll(".bls__collection-tab-item").forEach(
                  (element) => {
                    element.classList.remove("active");
                  }
                );
                this.classList.add("active");
                const tabId = this.dataset.id;
                currentArray = _this.loadArray(tabId);
                arrayTab = Array.from(
                  document.querySelectorAll(`#${tabId} .bls__product-load`)
                );
                currentPage = 1;
                paginationCurrent = document.querySelector(
                  `.pagination #${tabId}`
                );
                displayResults(currentArray, tabId);
                el.querySelectorAll(".bls__cls-tab").forEach((element) => {
                  if (element.id === tabId) {
                    if (!element.classList.contains("active")) {
                      el.querySelectorAll(".bls__cls-tab").forEach((elm) => {
                        elm.classList.remove("active");
                      });
                      element.classList.add("active");
                    }
                  }
                });

                el.querySelectorAll(".form-search-collection").forEach(
                  (element) => {
                    if (element.id === tabId) {
                      if (!element.classList.contains("active")) {
                        el.querySelectorAll(".form-search-collection").forEach(
                          (elm) => {
                            elm.classList.remove("active");
                          }
                        );
                        element.classList.add("active");
                      }
                    }
                  }
                );

                el.querySelectorAll(".pagination-tab").forEach((element) => {
                  if (element.id === "nav-" + tabId) {
                    if (!element.classList.contains("active")) {
                      el.querySelectorAll(".pagination-tab").forEach((elm) => {
                        elm.classList.remove("active");
                      });
                      element.classList.add("active");
                    }
                  }
                });
              }
            });
          });
        } else {
          const tabId = value;
          el.querySelectorAll(".bls__cls-tab").forEach((element) => {
            if (element.id === tabId) {
              if (!element.classList.contains("active")) {
                el.querySelectorAll(".bls__cls-tab").forEach((elm) => {
                  elm.classList.remove("active");
                });
                element.classList.add("active");
              }
            }
          });
        }
      });

      document.querySelectorAll(".search-input-collection").forEach((input) => {
        input.addEventListener("input", function () {
          const searchTerm = this.value;
          const arrayId = this.getAttribute("data-id");
          const results = searchArray(_this.loadArray(arrayId), searchTerm);
          currentPage = 1;
          displayResults(results, arrayId);
        });
      });

      function displayResults(results, arrayId) {
        if (!enableSearch) return;
        const start = (currentPage - 1) * itemsPerPage;
        const end = start + itemsPerPage;
        let displayedCount = 0;
        arrayTab.forEach((item) => {
          if (results.includes(item.dataset.title)) {
            if (displayedCount >= start && displayedCount < end) {
              item.style.display = "block";
            } else {
              item.style.display = "none";
            }
            displayedCount++;
          } else {
            item.style.display = "none";
          }
          if (results.length > itemsPerPage) {
            paginationCurrent.style.display = "flex";
            displayPagination(displayedCount, arrayId, paginationCurrent);
          } else {
            paginationCurrent.style.display = "none";
          }
          const contentNoResult = document.querySelector(
            `#${arrayId} .no-result`
          );
          if (results.length === 0) {
            contentNoResult.style.display = "block";
          } else {
            contentNoResult.style.display = "none";
          }
        });
      }

      function displayPagination(totalItems, arrayId, pagination) {
        if (!enableSearch) return;
        const totalPages = Math.ceil(totalItems / itemsPerPage);
        pagination.innerHTML = "";

        const prevButton = document.createElement("li");
        const aPrevButton = document.createElement("a");
        aPrevButton.setAttribute("role", "link");
        aPrevButton.classList.add(
          "pagination__item",
          "pagination__item--next",
          "pagination__item-arrow",
          "link",
          "motion-reduce"
        );
        aPrevButton.textContent = "Back";
        prevButton.appendChild(aPrevButton);
        if (currentPage === 1) {
          prevButton.classList.add("disabled");
        }
        prevButton.addEventListener("click", function () {
          if (currentPage > 1) {
            currentPage--;
            const searchTerm = document.querySelector(
              `input[data-id="${arrayId}"]`
            ).value;
            const results = searchArray(_this.loadArray(arrayId), searchTerm);
            displayResults(results, arrayId);
          }
        });
        pagination.appendChild(prevButton);

        for (let i = 1; i <= totalPages; i++) {
          const button = document.createElement("li");
          const aButton = document.createElement("a");
          aButton.setAttribute("role", "link");
          aButton.setAttribute("aria-label", `Page ${currentPage}`);
          aButton.classList.add("pagination__item", "link");
          aButton.textContent = i;
          if (i === currentPage) {
            aButton.classList.add("pagination__item--current");
          }
          button.appendChild(aButton);
          button.addEventListener("click", function () {
            currentPage = i;
            const searchTerm = document.querySelector(
              `input[data-id="${arrayId}"]`
            ).value;
            const results = searchArray(_this.loadArray(arrayId), searchTerm);
            displayResults(results, arrayId);
          });
          pagination.appendChild(button);
        }

        const nextButton = document.createElement("li");
        const aNextButton = document.createElement("a");
        aNextButton.setAttribute("role", "link");
        aNextButton.classList.add(
          "pagination__item",
          "pagination__item--prev",
          "pagination__item-arrow",
          "link",
          "motion-reduce"
        );
        aNextButton.textContent = "Next";
        nextButton.appendChild(aNextButton);
        if (currentPage === totalPages) {
          nextButton.classList.add("disabled");
        }
        nextButton.addEventListener("click", function () {
          if (currentPage < totalPages) {
            currentPage++;
            const searchTerm = document.querySelector(
              `input[data-id="${arrayId}"]`
            ).value;
            const results = searchArray(_this.loadArray(arrayId), searchTerm);
            displayResults(results, arrayId);
          }
        });
        pagination.appendChild(nextButton);
      }

      function searchArray(array, searchTerm) {
        return array.filter((item) =>
          item.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }
    },

    setupDropdownStyle: function () {
      const _this = this;
      var x, i, j, l, ll, selElmnt, a, b, z, p, o;
      x = document.getElementsByClassName("custom-select");
      l = x.length;
      if (l > 0) {
        for (i = 0; i < l; i++) {
          selElmnt = x[i].getElementsByTagName("select")[0];
          x[i].innerHTML = "";
          x[i].appendChild(selElmnt);
          ll = selElmnt.length;
          a = document.createElement("div");
          a.setAttribute(
            "class",
            "select-selected flex justify-content-between w-full"
          );
          p = document.createElement("span");
          p.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
          a.appendChild(p);
          o = document.createElement("span");
          o.setAttribute("class", "select-arrow");
          o.innerHTML = `<svg fill="currentColor" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"></path></svg>`;
          a.appendChild(o);
          x[i].appendChild(a);
          b = document.createElement("div");
          b.setAttribute("class", "select-items select-hide");
          for (j = 0; j < ll; j++) {
            z = document.createElement("div");
            z.innerHTML = selElmnt.options[j].innerHTML;
            if (selElmnt.options[j].getAttribute("selected")) {
              z.setAttribute("class", "same-as-selected");
            }
            z.addEventListener("click", function (e) {
              var y, i, k, s, h, sl, yl;
              s = this.parentNode.parentNode.getElementsByTagName("select")[0];
              sl = s.length;
              h = this.parentNode.previousSibling;
              for (i = 0; i < sl; i++) {
                if (s.options[i].innerHTML == this.innerHTML) {
                  s.selectedIndex = i;
                  h.childNodes[0].innerHTML = this.innerHTML;
                  y =
                    this.parentNode.getElementsByClassName("same-as-selected");
                  yl = y.length;
                  for (k = 0; k < yl; k++) {
                    y[k].removeAttribute("class");
                  }
                  this.setAttribute("class", "same-as-selected");
                  break;
                }
              }
              s.dispatchEvent(new Event("change"));
              s.dispatchEvent(new Event("click"));
              h.click();
            });
            b.appendChild(z);
          }
          x[i].appendChild(b);
          a.addEventListener("click", function (e) {
            e.stopPropagation();
            _this.closeAllSelect(this);
            this.nextSibling.classList.toggle("select-hide");
            this.classList.toggle("select-arrow-active");
            _this.setupEventListeners(
              this.closest(".custom-select").querySelector(".select-data").value
            );
          });
        }
      }
    },
    closeAllSelect: function (elmnt) {
      var x,
        y,
        i,
        xl,
        yl,
        arrNo = [];
      x = document.getElementsByClassName("select-items");
      y = document.getElementsByClassName(
        "select-selected flex justify-content-between w-full"
      );
      xl = x.length;
      yl = y.length;
      for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
          arrNo.push(i);
        } else {
          y[i].classList.remove("select-arrow-active");
        }
      }
      for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
          x[i].classList.add("select-hide");
        }
      }
    },
    loadArray: function (id) {
      const dataScript = document.getElementById(`title-${id}`);
      if (dataScript) {
        return JSON.parse(dataScript.textContent);
      }
    },
  };
})();
BlsProductTabEvents.init();

var BlsCountdownTimer = (function () {
  return {
    init: function () {
      this.handleCountdown();
      this.eventCountDownTimer();
    },

    eventCountDownTimer: function () {
      const element = document.querySelectorAll(".bls__countdown-timer");

      if (element.length === 0) return;
      element.forEach((e) => {
        const day = e.getAttribute("data-days");
        const hrs = e.getAttribute("data-hrs");
        const secs = e.getAttribute("data-secs");
        const mins = e.getAttribute("data-mins");
        const time = e.getAttribute("data-time");
        var countDownDate = new Date(time).getTime();
        var timer = setInterval(function () {
          var now = new Date().getTime();
          var distance = countDownDate - now;
          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);
          var html =
            '<span class="countdown-days"><span class="countdown_ti heading-weight">' +
            days +
            '</span> <span class="countdown_tx">' +
            day +
            "</span></span> " +
            '<span class="countdown-hours"><span class="countdown_ti heading-weight">' +
            hours +
            '</span> <span class="countdown_tx">' +
            hrs +
            "</span></span> " +
            '<span class="countdown-min"><span class="countdown_ti heading-weight">' +
            minutes +
            '</span> <span class="countdown_tx">' +
            mins +
            "</span></span> " +
            '<span class="countdown-sec"><span class="countdown_ti heading-weight">' +
            seconds +
            '</span> <span class="countdown_tx">' +
            secs +
            "</span></span>";
          const cd = e.querySelector(".bls__product-countdown");
          if (cd) {
            cd.innerHTML = html;
          }
          if (distance < 0) {
            clearInterval(timer);
          }
        }, 1000);
      });
    },

    handleCountdown: function () {
      var second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;
      const timer = document.querySelectorAll(".bls__timer");
      timer.forEach((e) => {
        const { timer } = e?.dataset;
        const dateParts = timer.split("-");
        const isoDate =
          dateParts[2] +
          "-" +
          dateParts[0].padStart(2, "0") +
          "-" +
          dateParts[1].padStart(2, "0") +
          "T00:00:00Z";
        if (Date.parse(isoDate)) {
          var countDown = new Date(isoDate).getTime();
          if (countDown) {
            setInterval(function () {
              var now = new Date().getTime(),
                distance = countDown - now;
              if (countDown >= now) {
                (e.querySelector(".js-timer-days").innerText =
                  Math.floor(distance / day) < 10
                    ? ("0" + Math.floor(distance / day)).slice(-2)
                    : Math.floor(distance / day)),
                  (e.querySelector(".js-timer-hours").innerText = (
                    "0" + Math.floor((distance % day) / hour)
                  ).slice(-2)),
                  (e.querySelector(".js-timer-minutes").innerText = (
                    "0" + Math.floor((distance % hour) / minute)
                  ).slice(-2)),
                  (e.querySelector(".js-timer-seconds").innerText = (
                    "0" + Math.floor((distance % minute) / second)
                  ).slice(-2));
              }
            }, second);
          }
        }
      });
    },
  };
})();
BlsCountdownTimer.init();

var BlsReloadSpr = (function () {
  return {
    init: function () {
      if (window.SPR) {
        window.SPR.registerCallbacks();
        window.SPR.initRatingHandler();
        window.SPR.initDomEls();
        window.SPR.loadProducts();
        window.SPR.loadBadges();
      }
    },
  };
})();

var HeaderNavMount = (function () {
  function mount() {
    const header = document.querySelector("[data-header-layout]");
    if (header?.getAttribute("data-header-layout") === "h_layout2") return;

    const mountEl = document.querySelector("[data-header-navigation-mount]");
    const anchor = document.querySelector("[data-header-nav-anchor]");
    if (!mountEl || !anchor) return;
    if (mountEl.parentElement === anchor) {
      mountEl.classList.add("header-navigation-mount--placed");
      return;
    }
    anchor.appendChild(mountEl);
    mountEl.classList.add("header-navigation-mount--placed");
  }

  return { mount };
})();

var MobileNavPortal = (function () {
  const MOBILE_NAV_MAX = 1024;
  let nav = null;
  let home = null;

  function isMobileNavViewport() {
    return window.innerWidth <= MOBILE_NAV_MAX;
  }

  function mount() {
    nav = document.querySelector(".navigation.bls__canvas-mb-menu");
    if (!nav || nav.dataset.navPortalMounted === "true") return;
    home = { parent: nav.parentNode, next: nav.nextSibling };
    nav.dataset.navPortalMounted = "true";
  }

  function sync() {
    mount();
    if (!nav || !home?.parent) return;
    if (isMobileNavViewport()) {
      if (nav.parentNode !== document.body) {
        document.body.appendChild(nav);
      }
    } else if (nav.parentNode === document.body) {
      if (home.next) {
        home.parent.insertBefore(nav, home.next);
      } else {
        home.parent.appendChild(nav);
      }
    }
  }

  function setBackdrop(open) {
    const overlay = document.querySelector(global.overlay);
    if (!overlay) return;
    if (open) {
      overlay.classList.remove("d-none-overlay");
      return;
    }
    const html = document.documentElement;
    if (
      html.classList.contains("nav-open") ||
      html.classList.contains("open-search") ||
      html.classList.contains("hside_opened") ||
      html.classList.contains("vetical-overlay") ||
      document.querySelector(".bls__opend-popup") ||
      document.getElementById("bls-header_minicart")?.classList.contains(
        "bls__opend-popup-header"
      )
    ) {
      return;
    }
    overlay.classList.add("d-none-overlay");
  }

  return {
    mount,
    sync,
    open: function () {
      sync();
      setBackdrop(true);
    },
    close: function () {
      setBackdrop(false);
    },
  };
})();

var BlsMainMenuShopify = (function () {
  return {
    init: function () {
      this.initMainMenu();
      this.initVerticalMenu();
    },
    initMainMenu: function () {
      var _this = this;
      HeaderNavMount.mount();
      MobileNavPortal.mount();
      document.addEventListener("shopify:section:load", () => {
        HeaderNavMount.mount();
        MobileNavPortal.mount();
        MobileNavPortal.sync();
      });
      window.addEventListener(
        "resize",
        () => {
          MobileNavPortal.sync();
        },
        { passive: true }
      );
      const header = document.querySelector(global.header);
      const sticky = header?.getAttribute("data-sticky");
      const sticky_mobile = header?.getAttribute("data-sticky-mobile");
      const verticalmenu = document.querySelector(".verticalmenu-list");
      const bls_main_menu = document.querySelector(".bls_main_menu");
      var menu_parent = "li.bls__menu-parent";

      // _this.onMenuMobileItem();
      _this.loadMoreMenu();
      document.querySelectorAll(".nav-toggle").forEach((navToggle) => {
        navToggle.addEventListener("click", () => {
          if (document.documentElement.classList.contains("nav-open")) {
            document.documentElement.classList.remove("nav-open");
            MobileNavPortal.close();
            if (!bls_main_menu) {
              document.documentElement.classList.remove("nav-verticalmenu");
            }
          } else {
            MobileNavPortal.open();
            document.documentElement.classList.add("nav-open");
            if (!bls_main_menu) {
              document.documentElement.classList.add("nav-verticalmenu");
            }
          }
        });
      });

      document.querySelectorAll(".close-menu").forEach((closeToggle) => {
        closeToggle.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            document.documentElement.classList.remove("nav-open");
            MobileNavPortal.close();
          },
          false
        );
      });

      if (verticalmenu && bls_main_menu) {
        const article = document.querySelector(".verticalmenu-html");
        const limitItemShow = article.dataset.limitshowitem;
        const html_title =
          '<a data-menu="verticalmenu-list" href="#">' +
          window.menuStrings?.verticalTitle +
          "</a>";
        const verticalmenu_html =
          document.querySelector(".verticalmenu-list").innerHTML;
        const el = document.createElement("ul");
        el.classList.add("verticalmenu-list");
        el.classList.add("verticalmenu-mobile");
        el.style.display = "none";
        el.setAttribute("data-limitshowitem", limitItemShow);
        el.innerHTML = verticalmenu_html;
        document
          .querySelector(".bls_main_menu .mobile-menu-content")
          .appendChild(el);
        document
          .querySelector(".bls_main_menu .menu-mobile-title")
          .insertAdjacentHTML("beforeend", html_title);
        // _this.onMenuMobileItem("verticalmenu");
      }

      document
        .querySelectorAll(".bls_main_menu .menu-mobile-title a")
        .forEach((navToggle) => {
          navToggle.addEventListener(
            "click",
            (e) => {
              e.preventDefault();
              const target = e.currentTarget;
              const data = target.getAttribute("data-menu");
              for (var item_title of document.querySelectorAll(
                ".bls_main_menu .menu-mobile-title a"
              )) {
                item_title.classList.remove("active");
              }
              target.classList.add("active");
              for (var item_menu of document.querySelectorAll(
                ".bls_main_menu .mobile-menu-content > ul"
              )) {
                item_menu.style.display = "none";
              }
              document.querySelector(
                ".bls_main_menu ." + data + ""
              ).style.display = "block";
            },
            false
          );
        });
      let width = screen.width;
      document
        .querySelectorAll("li.bls__menu-parent")
        .forEach((menuItem, index) => {
          if (width > 1024) {
            menuItem.addEventListener("mouseenter", (e) => {
              _this.onMenuItemEnter(menuItem, index);
            });
            menuItem.addEventListener("mouseleave", (e) =>
              _this.onMenuItemLeave(menuItem, index)
            );
          }
        });

      document
        .querySelectorAll(".bls-menu-item.type_banner")
        .forEach((menuItem, index) => {
          if (menuItem.classList.contains("space-banner")) {
            menuItem.closest(".submenu").classList.add("submenu-space-banner");
          }
        });

      let windowWidth = window.innerWidth;
      window.addEventListener("resize", function () {
        windowWidth = window.innerWidth;
        ac(windowWidth);
      });
      function ac(windowWidth) {
        if (document.querySelectorAll("li.advanced-content > .sub").length) {
          if (windowWidth <= 1024) {
            for (var item_content of document.querySelectorAll(
              "li.advanced-content > .sub"
            )) {
              item_content.classList.remove("active");
            }
          } else {
            for (var item_content of document.querySelectorAll(
              "li.advanced-content > .sub"
            )) {
              item_content.classList.add("active");
              break;
            }
          }
        }
      }
      ac(windowWidth);
      document.querySelectorAll("li.advanced-main a").forEach((item) => {
        item.addEventListener(
          "mouseenter",
          (e) => {
            const target = e.currentTarget;
            const data = target.getAttribute("data-link");
            if (data) {
              for (var item_content of document.querySelectorAll(
                "li.advanced-content > .sub"
              )) {
                item_content.classList.remove("active");
              }
              for (var item of document.querySelectorAll(
                "li.advanced-main a"
              )) {
                item.classList.remove("active");
              }

              target.classList.add("active");
              if (document.querySelector(data)) {
                document.querySelector(data).classList.add("active");
              }
            }
          },
          false
        );
      });
      function getVisibleOffsetHeight(el) {
        if (!el) return 0;
        const style = window.getComputedStyle(el);
        if (style.display === "none" || style.visibility === "hidden") return 0;
        const rect = el.getBoundingClientRect();
        if (rect.height <= 0 || rect.width <= 0) return 0;
        return Math.round(rect.height);
      }

      const announcementEl = document.getElementById("announcement-bar");
      const topbarEl = document.querySelector("#page-header .topbar");
      const MOBILE_MAX = 1024;

      function isLayout2Mobile() {
        return window.innerWidth <= MOBILE_MAX;
      }

      function getLayoutWrapperInset() {
        const wrapper = document.querySelector(".bls-wrapper");
        if (!wrapper || !document.body.classList.contains("layout-radial")) {
          return 0;
        }
        return Math.round(parseFloat(getComputedStyle(wrapper).paddingTop) || 0);
      }

      function getAnnouncementBarHeight() {
        return getVisibleOffsetHeight(announcementEl);
      }

      function getMobileHeaderTopBelowAnnouncement() {
        if (!announcementEl) return 0;
        const rect = announcementEl.getBoundingClientRect();
        if (rect.bottom <= 0) return 0; 
        return Math.round(rect.bottom);
      }

      let headerbar = getVisibleOffsetHeight(announcementEl);
      let headertopbar = getVisibleOffsetHeight(topbarEl);
      let headerpage =
        document.getElementById("sticky-header")?.offsetHeight ||
        document.getElementById("page-header")?.offsetHeight ||
        0;

      function syncHeaderCssVars() {
        const wrapperPad = getLayoutWrapperInset();
        headerbar = getAnnouncementBarHeight();
        headertopbar = getVisibleOffsetHeight(topbarEl);
        headerpage =
          document.getElementById("sticky-header")?.offsetHeight ||
          document.getElementById("page-header")?.offsetHeight ||
          0;
        const body = document.body;
        const root = document.documentElement;
        root.style.setProperty("--h-layout2-wrapper-inset", wrapperPad + "px");
        body.style.setProperty("--height-bar", headerbar + "px");
        body.style.setProperty("--height-topbar", headertopbar + "px");
        body.style.setProperty("--height-header", headerpage + "px");
        body.style.setProperty("--h-layout2-header-h", headerpage + "px");
        body.style.setProperty(
          "--h-layout2-stack-h",
          wrapperPad + headerbar + headerpage + "px"
        );
        body.classList.toggle("h-layout2-mobile", isLayout2Mobile());
      }

      syncHeaderCssVars();
      if (sticky == "true") {
        // const stickyHeaderEl = document.getElementById("sticky-header");
        const stickyHeaderEl = document.getElementById("sticky-header");
        let headerSpaceH = stickyHeaderEl?.offsetHeight || 0;
        let activateY = 0;
        let lastScroll = window.pageYOffset || 0;
        const layout2GapRem = 1.2;
        const rem =
          parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
        const layout2Gap = layout2GapRem * rem;
        const isLayout2Sticky = header.classList.contains("h_layout2-smart-sticky");

        function setHeaderHidden(hidden) {
          if (!isLayout2Sticky) return;
          header.classList.toggle("header_scroll_up", hidden);
        }

        function updateLayout2StickyTop(currentScroll) {
          if (!isLayout2Sticky) return;
          const isVisible = !header.classList.contains("header_scroll_up");
          let topPx;
          if (currentScroll <= activateY) {
            topPx = Math.max(0, activateY - currentScroll);
          } else if (isLayout2Mobile()) {
            if (!isVisible) {
              topPx = getMobileHeaderTopBelowAnnouncement();
            } else {
              topPx = getMobileHeaderTopBelowAnnouncement();
            }
          } else {
            topPx = 0;
          }
          header.style.setProperty("--h-layout2-sticky-top", topPx + "px");
        }

        function getLayout2ActivateY() {
          const wrapperPad = getLayoutWrapperInset();
          headerbar = getAnnouncementBarHeight();
          const gap = 0;
          return wrapperPad + headerbar + gap;
        }

        function observeAnnouncementResize() {
          if (!announcementEl || typeof ResizeObserver === "undefined") return;
          const observer = new ResizeObserver(() => {
            updateStickyHeights();
          });
          observer.observe(announcementEl);
        }

        function updateStickyHeights() {
          headerSpaceH = stickyHeaderEl?.offsetHeight || 0;
          activateY = getLayout2ActivateY();
          const gapPx = headerbar > 0 && !isLayout2Mobile() ? layout2Gap : 0;
          header.style.setProperty("--h-layout2-gap", gapPx + "px");
          header.classList.toggle("h_layout2-has-offset", activateY > 0);
          syncHeaderCssVars();
          updateLayout2StickyTop(window.pageYOffset || 0);
        }

        updateStickyHeights();
        observeAnnouncementResize();

        window.addEventListener(
          "resize",
          () => {
            syncHeaderCssVars();
            updateStickyHeights();
          },
          { passive: true }
        );

        window.addEventListener(
          "orientationchange",
          () => {
            syncHeaderCssVars();
            updateStickyHeights();
          },
          { passive: true }
        );

        const headerMiddleEl = header.querySelector(".header-middle");
        let blsTransparentTicking = false;
        window.addEventListener(
          "scroll",
          () => {
            // Cache .header-middle + coalesce to one rAF/frame so we don't run a
            // querySelector + offsetTop read (forced reflow) on every scroll event.
            if (blsTransparentTicking) return;
            blsTransparentTicking = true;
            window.requestAnimationFrame(() => {
              blsTransparentTicking = false;
              const currentScroll = window.pageYOffset;
              if (headerMiddleEl && currentScroll <= headerMiddleEl.offsetTop) {
                if (header.classList.contains("transparent")) {
                  header.classList.add("transparent");
                }
                return;
              }
              if (header.classList.contains("transparent")) {
                header.classList.remove("transparent");
              }
            });
          },
          { passive: true }
        );
        const SCROLL_DELTA = 3;
        let ticking = false;

        window.addEventListener(
          "scroll",
          () => {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(() => {
              ticking = false;
              stickyFunction();
            });
          },
          { passive: true }
        );

        function stickyFunction() {
          const currentScroll = window.pageYOffset || 0;
          const delta = currentScroll - lastScroll;
          lastScroll = currentScroll;

          if (!isLayout2Sticky) {
            if (currentScroll > activateY + 200) {
              BlsOptimize();
            }
            return;
          }

          if (currentScroll <= activateY) {
            setHeaderHidden(false);
            updateLayout2StickyTop(currentScroll);
            return;
          }

          if (Math.abs(delta) >= SCROLL_DELTA) {
            if (delta > 0) {
              setHeaderHidden(true);
            } else {
              setHeaderHidden(false);
            }
          }

          updateLayout2StickyTop(currentScroll);

          if (currentScroll > activateY + 200) {
            BlsOptimize();
            if (document.querySelector(".extent-button-right-bar")) {
              document
                .querySelector(".extent-button-right-bar")
                .classList.add("d-xxl-block");
              let extentButtonRightBar = document.querySelector(
                ".extent-button-right-bar"
              );
              let btnFixed = document.querySelector(".btn-fixed");
              if (btnFixed === null) {
                let htmlbuttonright = `<div class="btn-fixed">
                  <a class="demo content-fixed pointer" role="link" aria-label="Select Demos">
                    <span class="icon-btn">
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.2406 0.780116C10.7017 0.346314 11.3492 0.218262 12.0519 0.218262H15.3573C16.06 0.218262 16.7074 0.346314 17.1686 0.780116C17.6389 1.22258 17.7819 1.85492 17.7819 2.53644V8.10008C17.7819 8.7816 17.6389 9.41395 17.1686 9.85641C16.7074 10.2902 16.06 10.4183 15.3573 10.4183H12.0519C11.3492 10.4183 10.7017 10.2902 10.2406 9.85641C9.77031 9.41395 9.62732 8.7816 9.62732 8.10008V2.53644C9.62732 1.85492 9.77031 1.22258 10.2406 0.780116ZM11.0629 1.65413C10.9461 1.76395 10.8273 1.99069 10.8273 2.53644V8.10008C10.8273 8.64583 10.9461 8.87258 11.0629 8.98239C11.1888 9.10086 11.4537 9.21826 12.0519 9.21826H15.3573C15.9555 9.21826 16.2204 9.10086 16.3463 8.98239C16.463 8.87258 16.5819 8.64583 16.5819 8.10008V2.53644C16.5819 1.99069 16.463 1.76395 16.3463 1.65413C16.2204 1.53566 15.9555 1.41826 15.3573 1.41826H12.0519C11.4537 1.41826 11.1888 1.53566 11.0629 1.65413Z" fill="#212529"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.2406 12.2345C10.7017 11.8007 11.3492 11.6726 12.0519 11.6726H15.3573C16.06 11.6726 16.7074 11.8007 17.1686 12.2345C17.6389 12.6769 17.7819 13.3093 17.7819 13.9908V15.4635C17.7819 16.145 17.6389 16.7774 17.1686 17.2198C16.7074 17.6536 16.06 17.7817 15.3573 17.7817H12.0519C11.3492 17.7817 10.7017 17.6536 10.2406 17.2198C9.77031 16.7774 9.62732 16.145 9.62732 15.4635V13.9908C9.62732 13.3093 9.77031 12.6769 10.2406 12.2345ZM11.0629 13.1085C10.9461 13.2183 10.8273 13.445 10.8273 13.9908V15.4635C10.8273 16.0093 10.9461 16.236 11.0629 16.3458C11.1888 16.4643 11.4537 16.5817 12.0519 16.5817H15.3573C15.9555 16.5817 16.2204 16.4643 16.3463 16.3458C16.463 16.236 16.5819 16.0093 16.5819 15.4635V13.9908C16.5819 13.445 16.463 13.2183 16.3463 13.1085C16.2204 12.99 15.9555 12.8726 15.3573 12.8726H12.0519C11.4537 12.8726 11.1888 12.99 11.0629 13.1085Z" fill="#212529"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.6537 9.01766C1.53697 9.12747 1.41814 9.35422 1.41814 9.89997V15.4636C1.41814 16.0094 1.53697 16.2361 1.6537 16.3459C1.77962 16.4644 2.04448 16.5818 2.64269 16.5818H5.94814C6.54634 16.5818 6.8112 16.4644 6.93713 16.3459C7.05385 16.2361 7.17269 16.0094 7.17269 15.4636V9.89997C7.17269 9.35422 7.05385 9.12747 6.93713 9.01766C6.8112 8.89919 6.54634 8.78179 5.94814 8.78179H2.64269C2.04448 8.78179 1.77962 8.89919 1.6537 9.01766ZM0.831448 8.14364C1.29256 7.70984 1.93998 7.58179 2.64269 7.58179H5.94814C6.65085 7.58179 7.29826 7.70984 7.75938 8.14364C8.2297 8.5861 8.37269 9.21845 8.37269 9.89997V15.4636C8.37269 16.1451 8.2297 16.7775 7.75938 17.2199C7.29826 17.6537 6.65085 17.7818 5.94814 17.7818H2.64269C1.93998 17.7818 1.29256 17.6537 0.831448 17.2199C0.361128 16.7775 0.21814 16.1451 0.21814 15.4636V9.89997C0.21814 9.21844 0.361128 8.5861 0.831448 8.14364Z" fill="#212529"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.6537 1.65413C1.53697 1.76395 1.41814 1.99069 1.41814 2.53644V4.00917C1.41814 4.55492 1.53697 4.78167 1.6537 4.89148C1.77962 5.00995 2.04448 5.12735 2.64269 5.12735H5.94814C6.54634 5.12735 6.8112 5.00995 6.93713 4.89148C7.05385 4.78167 7.17269 4.55492 7.17269 4.00917V2.53644C7.17269 1.99069 7.05385 1.76395 6.93713 1.65413C6.8112 1.53566 6.54634 1.41826 5.94814 1.41826H2.64269C2.04448 1.41826 1.77962 1.53566 1.6537 1.65413ZM0.831448 0.780116C1.29256 0.346314 1.93998 0.218262 2.64269 0.218262H5.94814C6.65085 0.218262 7.29826 0.346314 7.75938 0.780116C8.2297 1.22258 8.37269 1.85492 8.37269 2.53644V4.00917C8.37269 4.69069 8.2297 5.32304 7.75938 5.7655C7.29826 6.1993 6.65085 6.32735 5.94814 6.32735H2.64269C1.93998 6.32735 1.29256 6.1993 0.831448 5.7655C0.361128 5.32304 0.21814 4.69069 0.21814 4.00917V2.53644C0.21814 1.85492 0.361128 1.22258 0.831448 0.780116Z" fill="#212529"/>
                      </svg>
                    </span>
                    <span class="box-desc tooltip-f"> Select Demos </span>
                  </a>
                  <a
                    href="https://blueskytechmage.com/shopify/uminio-theme/#features"
                    aria-label="Features"
                    class="content-fixed"
                    target="_blank"
                  >
                    <span class="icon-btn">
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="18" height="18" fill="none"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.54404 1.54059C2.65827 0.42709 4.3263 0 6.48283 0H11.5172C13.6737 0 15.3417 0.42709 16.456 1.54059C17.5716 2.65555 18 4.32629 18 6.48447V11.5155C18 13.6737 17.5716 15.3445 16.456 16.4594C15.3417 17.5729 13.6737 18 11.5172 18H6.48283C4.3263 18 2.65827 17.5729 1.54404 16.4594C0.428359 15.3445 0 13.6737 0 11.5155V6.48447C0 4.32629 0.428359 2.65555 1.54404 1.54059ZM2.40174 2.41437C1.62954 3.18607 1.21884 4.45011 1.21884 6.48447V11.5155C1.21884 13.5499 1.62954 14.8139 2.40174 15.5856C3.17539 16.3588 4.44406 16.7702 6.48283 16.7702H11.5172C13.5559 16.7702 14.8246 16.3588 15.5983 15.5856C16.3705 14.8139 16.7812 13.5499 16.7812 11.5155V6.48447C16.7812 4.45011 16.3705 3.18607 15.5983 2.41437C14.8246 1.64123 13.5559 1.22981 11.5172 1.22981H6.48283C4.44406 1.22981 3.17539 1.64123 2.40174 2.41437Z" fill="#212529"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.93317 4.37377C9.63723 3.61699 10.953 4.08433 10.953 5.1047V7.84039H11.8419C12.8317 7.84039 13.3686 8.95684 12.7098 9.67166C12.7097 9.67173 12.7099 9.6716 12.7098 9.67166L9.06683 13.6262C8.36277 14.383 7.047 13.9157 7.047 12.8953V10.1596H6.15811C5.16826 10.1596 4.63139 9.04315 5.2902 8.32833C5.29026 8.32827 5.29014 8.3284 5.2902 8.32833L8.93317 4.37377ZM9.75641 5.21051L6.25047 9.01633H7.6453C7.97572 9.01633 8.24359 9.27226 8.24359 9.58797V12.7895L11.7495 8.98367H10.3547C10.0243 8.98367 9.75641 8.72773 9.75641 8.41203V5.21051Z" fill="#212529"/>
                      </svg>
                    </span>
                    <span class="box-desc tooltip-f"> Features </span>
                  </a>
                  <a
                    href="https://themeforest.net/item/umino-multipurpose-shopify-themes-os-20/42969030"
                    aria-label="Buy Now"
                    target="_blank"
                    class="content-fixed show-mobile"
                  >
                    <span class="icon-btn">
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.26846 10.156C6.59983 10.156 6.86846 10.4246 6.86846 10.756C6.86846 11.9231 7.83292 12.8875 9 12.8875C10.1671 12.8875 11.1315 11.9231 11.1315 10.756C11.1315 10.4246 11.4002 10.156 11.7315 10.156C12.0629 10.156 12.3315 10.4246 12.3315 10.756C12.3315 12.5858 10.8298 14.0875 9 14.0875C7.17018 14.0875 5.66846 12.5858 5.66846 10.756C5.66846 10.4246 5.93709 10.156 6.26846 10.156Z" fill="#111111"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.93408 0.770732C7.16872 1.00472 7.16924 1.38462 6.93525 1.61926L4.11005 4.45226C3.87606 4.6869 3.49616 4.68742 3.26153 4.45343C3.02689 4.21944 3.02637 3.83954 3.26036 3.6049L6.08555 0.771903C6.31954 0.537265 6.69944 0.536741 6.93408 0.770732Z" fill="#111111"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.066 0.770732C11.3006 0.536741 11.6805 0.537265 11.9145 0.771903L14.7397 3.6049C14.9737 3.83954 14.9732 4.21944 14.7385 4.45343C14.5039 4.68742 14.124 4.6869 13.89 4.45226L11.0648 1.61926C10.8308 1.38462 10.8313 1.00472 11.066 0.770732Z" fill="#111111"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.03579 4.93786C1.9586 4.98956 1.79558 5.1378 1.79558 5.76122C1.79558 6.53405 1.97485 6.63591 2.00045 6.65046C2.00083 6.65067 2.00118 6.65087 2.00149 6.65105C2.04429 6.67571 2.1264 6.7033 2.29644 6.71579C2.42615 6.72532 2.55965 6.72432 2.72619 6.72307C2.7884 6.72261 2.85521 6.72211 2.92816 6.72211H15.0718C15.1448 6.72211 15.2116 6.72261 15.2738 6.72307C15.4403 6.72432 15.5738 6.72532 15.7035 6.71579C15.8736 6.7033 15.9557 6.67571 15.9985 6.65105L15.9995 6.65046C16.0251 6.63591 16.2044 6.53405 16.2044 5.76122C16.2044 5.1378 16.0414 4.98956 15.9642 4.93786C15.8225 4.84293 15.5702 4.80034 15.0718 4.80034H2.92816C2.42976 4.80034 2.17753 4.84293 2.03579 4.93786ZM1.368 3.94084C1.85256 3.61629 2.46661 3.60034 2.92816 3.60034H15.0718C15.5334 3.60034 16.1474 3.61629 16.632 3.94084C17.1811 4.30863 17.4044 4.94083 17.4044 5.76122C17.4044 6.65485 17.2027 7.34205 16.5977 7.69074C16.3273 7.84655 16.0363 7.89458 15.7915 7.91257C15.6088 7.92599 15.4055 7.92438 15.2249 7.92294C15.1715 7.92251 15.1201 7.92211 15.0718 7.92211H2.92816C2.87987 7.92211 2.82847 7.92251 2.7751 7.92294C2.59449 7.92438 2.3912 7.92599 2.2085 7.91257C1.96368 7.89458 1.67265 7.84655 1.40229 7.69074C0.797263 7.34205 0.595581 6.65485 0.595581 5.76122C0.595581 4.94083 0.818881 4.30863 1.368 3.94084Z" fill="#111111"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7467 6.84984C16.0721 6.91225 16.2854 7.22667 16.223 7.55211L14.9118 14.3886C14.9118 14.3887 14.9119 14.3885 14.9118 14.3886C14.7739 15.1091 14.593 15.9124 14.0279 16.5045C13.437 17.1236 12.5442 17.4044 11.2554 17.4044H6.54937C5.33588 17.4044 4.44854 17.1012 3.83769 16.4826C3.24376 15.8811 3.00535 15.0723 2.87463 14.2798L1.77404 7.53574C1.72067 7.20869 1.94252 6.90031 2.26957 6.84693C2.59661 6.79356 2.905 7.01542 2.95837 7.34246L4.05863 14.0845C4.0586 14.0843 4.05865 14.0846 4.05863 14.0845C4.17764 14.8057 4.36465 15.3084 4.69156 15.6394C5.00163 15.9535 5.5308 16.2044 6.54937 16.2044H11.2554C12.3938 16.2044 12.8941 15.9545 13.1598 15.676C13.4511 15.3707 13.5903 14.9096 13.7333 14.1629L15.0444 7.32609C15.1068 7.00065 15.4213 6.78743 15.7467 6.84984Z" fill="#111111"/>
                      </svg>
                    </span>
                    <span class="box-desc tooltip-f"> Buy Now </span>
                  </a>
                  <a
                    href="https://shopify.pxf.io/c/3722068/1061744/13624"
                    aria-label="Open Store"
                    target="_blank"
                    class="content-fixed"
                  >
                    <span class="icon-btn">
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.72023 7.79663C2.03319 7.79663 2.2869 8.05183 2.2869 8.36663V12.0126C2.2869 13.7784 2.64417 14.8673 3.30633 15.5295C3.96931 16.1925 5.06039 16.5503 6.8279 16.5503H11.2047C12.9723 16.5503 14.0633 16.1925 14.7263 15.5295C15.3885 14.8673 15.7457 13.7784 15.7457 12.0126V8.36663C15.7457 8.05183 15.9994 7.79663 16.3124 7.79663C16.6254 7.79663 16.8791 8.05183 16.8791 8.36663V12.0126C16.8791 13.8929 16.5055 15.3578 15.5253 16.338C14.546 17.3173 13.0832 17.6903 11.2047 17.6903H6.8279C4.9494 17.6903 3.48665 17.3173 2.50729 16.338C1.52712 15.3578 1.15356 13.8929 1.15356 12.0126V8.36663C1.15356 8.05183 1.40727 7.79663 1.72023 7.79663Z" fill="#111111"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.56445 0.822476C6.59366 0.531308 6.83732 0.309692 7.12826 0.309692H10.9204C11.2117 0.309692 11.4555 0.531786 11.4843 0.823321L12.0203 6.24768C12.1996 8.07135 10.839 9.56999 9.02029 9.56999C7.20157 9.56999 5.84091 8.0716 6.02028 6.24793L6.56445 0.822476ZM7.64063 1.44969L7.14811 6.36017C7.14809 6.36035 7.14813 6.36 7.14811 6.36017C7.03547 7.50828 7.86716 8.42999 9.02029 8.42999C10.1736 8.42999 11.0054 7.50853 10.8925 6.36017L10.4073 1.44969H7.64063Z" fill="#111111"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4677 0.497312C10.5751 0.377852 10.7278 0.309692 10.888 0.309692H13.3646C14.4858 0.309692 15.3931 0.52107 16.0521 1.12978C16.7043 1.73223 17.0057 2.6263 17.1578 3.72437C17.1587 3.73121 17.1595 3.73806 17.1602 3.74493L17.3877 5.97932C17.5838 7.94953 16.1173 9.56999 14.1442 9.56999C12.5168 9.56999 11.061 8.26389 10.8927 6.63078L10.8925 6.62899L10.3241 0.936659C10.3081 0.77638 10.3603 0.616773 10.4677 0.497312ZM11.5144 1.44969L12.02 6.51326C12.02 6.51298 12.0201 6.51355 12.02 6.51326C12.1283 7.55948 13.0922 8.42999 14.1442 8.42999C15.4515 8.42999 16.3885 7.38735 16.2601 6.09352C16.2601 6.0933 16.2601 6.09375 16.2601 6.09352L16.0339 3.87154C15.8933 2.86465 15.6431 2.29974 15.2855 1.96945C14.9335 1.64433 14.371 1.44969 13.3646 1.44969H11.5144Z" fill="#111111"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.93987 1.12978C2.59887 0.52107 3.50613 0.309692 4.62729 0.309692H7.10398C7.26414 0.309692 7.41681 0.377863 7.52425 0.497342C7.63168 0.616821 7.68383 0.776449 7.6678 0.93674L7.09955 6.62736C7.09952 6.6276 7.09957 6.62711 7.09955 6.62736C6.94048 8.26363 5.48231 9.56999 3.85586 9.56999C1.88289 9.56999 0.41646 7.94975 0.61227 5.9797C0.612257 5.97983 0.612283 5.97958 0.61227 5.9797L0.831483 3.74698C0.832225 3.73943 0.833116 3.73189 0.834157 3.72437C0.986197 2.6263 1.28765 1.73223 1.93987 1.12978ZM1.9582 3.87052L1.74008 6.0921C1.61131 7.38625 2.54836 8.42999 3.85586 8.42999C4.90886 8.42999 5.87042 7.55977 5.97157 6.51669L5.97171 6.51523L6.47745 1.44969H4.62729C3.62092 1.44969 3.05841 1.64433 2.70643 1.96945C2.34898 2.29963 2.09878 2.86427 1.9582 3.87052Z" fill="#111111"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.09724 13.1624C7.57954 12.6801 8.25662 12.4901 9.02033 12.4901C9.78403 12.4901 10.4611 12.6801 10.9434 13.1624C11.4263 13.6453 11.6171 14.3243 11.6171 15.0902V17.1203C11.6171 17.4351 11.3634 17.6903 11.0504 17.6903H6.99025C6.67729 17.6903 6.42358 17.4351 6.42358 17.1203V15.0902C6.42358 14.3243 6.61432 13.6453 7.09724 13.1624ZM7.89627 13.9708C7.70317 14.1639 7.55692 14.5 7.55692 15.0902V16.5503H10.4837V15.0902C10.4837 14.5 10.3375 14.1639 10.1444 13.9708C9.95067 13.7771 9.61271 13.6301 9.02033 13.6301C8.42794 13.6301 8.08999 13.7771 7.89627 13.9708Z" fill="#111111"/>
                      </svg>
                    </span>
                    <span class="box-desc tooltip-f"> Open Store </span>
                  </a>
                </div>`;
                extentButtonRightBar.insertAdjacentHTML(
                  "beforeend",
                  htmlbuttonright
                );
                extentButtonRightBar.init();
              }
            }
          } else {
            if (document.querySelector(".extent-button-right-bar")) {
              document
                .querySelector(".extent-button-right-bar")
                .classList.remove("d-xxl-block");
            }
            if (document.querySelector(".bls__overlay")) {
              document.documentElement.classList.remove("vetical-overlay");
              document
                .querySelector(".bls__overlay")
                .classList.add("d-none-overlay");
            }
            if (document.querySelector(".vertical-menu")) {
              if (
                document
                  .querySelector(".vertical-menu")
                  .classList.contains("open")
              ) {
                document
                  .querySelector(".vertical-menu")
                  .classList.remove("open");
              }
            }
          }
        }
      }

      if (bls_main_menu) {
        _this.addCssSubMenu();
        _this.loadImageMenu();
        window.addEventListener(
          "resize",
          function (event) {
            _this.addCssSubMenu();
          },
          true
        );
      }
    },
    initVerticalMenu: function () {
      document.querySelectorAll(".close-menu").forEach((closeToggle) => {
        closeToggle.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            document.documentElement.classList.remove("nav-open");
          },
          false
        );
      });
      let width = screen.width;
      const article = document.querySelector(".verticalmenu-html");
      if (article === null) return;
      const limitItemShow = article.dataset.limitshowitem;
      const lenghtLi = document.querySelectorAll(
        ".verticalmenu-html .level0"
      ).length;
      if (width > 1024) {
        if (lenghtLi > limitItemShow) {
          var lineItem = Array.from(
            document.querySelectorAll(".verticalmenu-html .level0")
          );
          lineItem.forEach((element, index) => {
            if (index > limitItemShow - 1) {
              const item = lineItem[index];
              if (item.classList.contains("expand-menu-link")) {
                return;
              }
              item.classList.add("orther-link");
              item.style.display = "none";
            }
          });
          document.querySelector(
            ".verticalmenu-html .expand-menu-link"
          ).style.display = "block";
          document
            .querySelector(".verticalmenu-html .expand-menu-link a")
            .addEventListener(
              "click",
              (e) => {
                e.preventDefault();
                const target = e.currentTarget;
                const parent = target.parentElement;
                if (!parent.classList.contains("expanding")) {
                  parent.classList.add("expanding");
                  parent.querySelector("a").innerHTML =
                    window.menuStrings?.hideMenus;
                  for (var item of document.querySelectorAll(
                    ".verticalmenu-html .level0.orther-link"
                  )) {
                    slideAnime({
                      target: item,
                      animeType: "slideDown",
                    });
                  }
                } else {
                  parent.classList.remove("expanding");
                  parent.querySelector("a").innerHTML =
                    window.menuStrings?.moreMenus;
                  for (var item of document.querySelectorAll(
                    ".verticalmenu-html .level0.orther-link"
                  )) {
                    slideAnime({
                      target: item,
                      animeType: "slideUp",
                    });
                  }
                }
              },
              false
            );
        } else {
          document.querySelector(".expand-menu-link").style.display = "none";
        }
      }
      if (document.querySelector(".bls_vertical_menu .title-menu-dropdown")) {
        document
          .querySelector(".bls_vertical_menu .title-menu-dropdown")
          .addEventListener("click", (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            const closest = target.closest(".vertical-menu");
            if (closest.classList.contains("open")) {
              closest.classList.remove("open");
              if (document.querySelector(".bls__overlay")) {
                document.documentElement.classList.remove("vetical-overlay");
                document
                  .querySelector(".bls__overlay")
                  .classList.add("d-none-overlay");
              }
            } else {
              closest.classList.add("open");
              if (document.querySelector(".bls__overlay")) {
                document.documentElement.classList.add("vetical-overlay");
                document
                  .querySelector(".bls__overlay")
                  .classList.remove("d-none-overlay");
              }
            }
          });
      }
    },
    onMenuItemEnter: function (evt, index) {
      const target = evt;
      target.classList.add("bls-item-active");
    },
    onMenuItemLeave: function (evt, index) {
      const target = evt;
      target.classList.remove("bls-item-active");
    },
    onMenuMobileItem: function (evt) {
      var menu_parent = "li.bls__menu-parent > .open-children-toggle";
      var menu_submenu = "li.bls__menu-parent .submenu .open-children-toggle";
      if (evt) {
        menu_parent =
          ".verticalmenu-list li.bls__menu-parent > .open-children-toggle";
        menu_submenu =
          ".verticalmenu-list li.bls__menu-parent .submenu .open-children-toggle";
      }
      document.querySelectorAll(menu_parent).forEach((childrenToggle) => {
        childrenToggle.addEventListener(
          "click",
          (e) => {
            e.preventDefault();
            const target = e.currentTarget;
            const parent = target.parentElement;
            const submenu = parent.querySelector(".submenu");
            slideAnime({
              target: submenu,
              animeType: "slideToggle",
            });
            if (!parent.querySelector("a").classList.contains("active")) {
              parent.querySelector("a").classList.add("active");
            } else {
              parent.querySelector("a").classList.remove("active");
            }
          },
          false
        );
      });

      document.querySelectorAll(menu_submenu).forEach((childrenToggle) => {
        childrenToggle.addEventListener("click", (e) => {
          const target = e.currentTarget;
          const parent = target.parentElement;
          const submenu = parent.querySelector(".subchildmenu");
          slideAnime({
            target: submenu,
            animeType: "slideToggle",
          });
          if (!parent.querySelector("a").classList.contains("active")) {
            parent.querySelector("a").classList.add("active");
          } else {
            parent.querySelector("a").classList.remove("active");
          }
        });
      });
    },
    addCssSubMenu: function () {
      const bodyWidth =
        document.documentElement.clientWidth || document.body.clientWidth;
      const header = document.querySelector("header");
      const submenu_center = document.querySelector(".bls_submenu-center");
      const width_sub_center = document
        .querySelector("[data-width-sub-center]")
        .getAttribute("data-width-sub-center");
      if (!header || bodyWidth < 1024) return;
      var padding = 30;
      if (bodyWidth < 1200) {
        padding = 15;
      }
      document
        .querySelectorAll(".horizontal-list .menu-width-custom > .submenu")
        .forEach((submenu) => {
          if (submenu_center) {
            var submenu_data = submenu.getBoundingClientRect();
            var width = submenu_data.width;
            var left = submenu_data.left;
            var right = submenu_data.right;
            if (width_sub_center <= width) {
              var left_style = (left - (right - bodyWidth)) / 2;
              submenu.style.left = left_style + "px";
            }
          } else {
            const elementWidth = submenu.clientWidth;
            const elementLeft = submenu.offsetLeft;
            if (bodyWidth - (elementWidth + elementLeft) < 0) {
              var left = bodyWidth - (elementWidth + elementLeft);
              left = left + elementLeft - padding;
              if (elementLeft < 0) {
                left = 0;
              }
              submenu.style.left = left + "px";
            }
          }
        });
    },
    loadImageMenu: function () {
      const menu_parent = document.querySelectorAll(".bls__menu-parent");
      var width = window.innerWidth;
      menu_parent.forEach((menu) => {
        menu.addEventListener("mouseover", (items) => {
          var target = items.currentTarget;
          target.querySelectorAll(".menu-banner-loaded").forEach((item) => {
            var dataImgBanner = item?.dataset.imageBanner;
            var dataImgWidth = item?.dataset.width;
            var dataImgHeight = item?.dataset.height;
            var img = item.querySelector(".image-banner-loaded");
            if (img == null && dataImgBanner != undefined) {
              item.innerHTML = `<img 
              src=${dataImgBanner} 
              alt="Menu banner" 
              srcset="${dataImgBanner}&amp;width=375 375w, ${dataImgBanner}&amp;width=550 550w, ${dataImgBanner}&amp;width=750 750w, ${dataImgBanner}&amp;width=1100 1100w, ${dataImgBanner}&amp;width=1500 1500w, ${dataImgBanner}&amp;width=1780 1780w, ${dataImgBanner}&amp;width=2000 2000w, ${dataImgBanner}&amp;width=3000 3000w, ${dataImgBanner}&amp;width=3840 3840w" 
              sizes="100vw",
              class="image-banner-loaded"
              loading="lazy"
              width="${dataImgWidth}"
              height="${dataImgHeight}"
            >`;
            }
          });
        });
      });
    },
    loadMoreMenu: function () {
      let firstMenuParent =
        document.querySelector(".horizontal-list")?.firstChild;
      let submenu = firstMenuParent?.querySelector(".submenu");
      let loadmore = submenu?.querySelector(".extent-loadmore-button");
      let loadmoreButton = document.querySelector(".loadmore-menu");
      if (loadmoreButton == null) {
        let loadmoreHtml = `<div class="loadmore-menu text-center">
          <a  class="demo whitespace-nowrap btn-primary" role="link" aria-label="View All Demos">
            View All Demos
          </a>
        </div>`;
        loadmore?.insertAdjacentHTML("beforeend", loadmoreHtml);
        loadmore?.init();
      }
    },
  };
})();
BlsMainMenuShopify.init();

var BlsMenuActionMobile = (function () {
  return {
    init: function () {
      this.menuTabActions();
      this.menuLoadMore();
    },
    menuLoadMore: function () {
      const article = document.querySelector(".verticalmenu-mobile");
      if (article === null) return;
      const limitItemShow = article.dataset.limitshowitem;
      const lenghtLi = document.querySelectorAll(
        ".verticalmenu-mobile .level0"
      ).length;
      if (lenghtLi > limitItemShow) {
        var lineItem = Array.from(
          document.querySelectorAll(".verticalmenu-mobile .level0")
        );
        lineItem.forEach((element, index) => {
          if (index > limitItemShow - 1) {
            const item = lineItem[index];
            if (item.classList.contains("expand-menu-link")) {
              return;
            }
            item.classList.add("orther-link");
            item.style.display = "none";
          }
        });
        document.querySelector(
          ".verticalmenu-mobile .expand-menu-link"
        ).style.display = "block";
        document
          .querySelector(".verticalmenu-mobile .expand-menu-link a")
          .addEventListener(
            "click",
            (e) => {
              e.preventDefault();
              const target = e.currentTarget;
              const parent = target.parentElement;
              if (!parent.classList.contains("expanding")) {
                parent.classList.add("expanding");
                parent.querySelector("a").innerHTML =
                  window.menuStrings?.hideMenus;
                for (var item of document.querySelectorAll(
                  ".verticalmenu-mobile .level0.orther-link"
                )) {
                  slideAnime({
                    target: item,
                    animeType: "slideDown",
                  });
                }
              } else {
                parent.classList.remove("expanding");
                parent.querySelector("a").innerHTML =
                  window.menuStrings?.moreMenus;
                for (var item of document.querySelectorAll(
                  ".verticalmenu-mobile .level0.orther-link"
                )) {
                  slideAnime({
                    target: item,
                    animeType: "slideUp",
                  });
                }
              }
            },
            false
          );
      } else {
        document.querySelector(".expand-menu-link").style.display = "none";
      }
    },
    menuTabActions: function () {
      var back_main_menu = ".back-main-menu",
        back_main_menu_lv1 = ".back-main-menu-lv1",
        back_main_menu_lv2 = ".back-main-menu-lv2",
        back_main_menu_lv3 = ".back-main-menu-lv3",
        menu_parent_link = "li.bls__menu-parent > a",
        menu_parent = "li.bls__menu-parent > .open-children-toggle",
        submenu = ".submenu",
        subchildmenu = ".subchildmenu",
        menu_lv2 = "[data-menu-level2]",
        dropdown_lv2 = ".submenu .dropdown li.level-1 > .open-children-toggle",
        dropdown_lv3 = ".submenu .dropdown li.level-2 > .open-children-toggle";
      let windowWidth = window.innerWidth;
      if (windowWidth <= 1024) {
        document.querySelectorAll(menu_parent_link).forEach((link) => {
          const main = link
            .closest(".main-nav")
            .getAttribute("data-action-mobile");
          if (main === "false") {
            link.removeAttribute("href");
            link.classList.add("not-links");
            link.setAttribute("role", "link");
          }
        });
      }
      document.querySelectorAll(menu_parent).forEach((main) => {
        main.addEventListener("click", (e) => {
          const target = e.currentTarget;
          const parent = target.parentElement;
          var menu_lv2_nodes = parent.querySelectorAll(
            ".submenu [data-menu-level2]"
          );
          if (menu_lv2_nodes) {
            var menu_lv2_last = menu_lv2_nodes[menu_lv2_nodes.length - 1];
            if (menu_lv2_last) {
              menu_lv2_last.classList.add("last-child");
            }
          }
          if (
            !parent.querySelector(".submenu").classList.contains("is--open")
          ) {
            parent.querySelector(".submenu").classList.add("is--open");
          } else {
            parent.querySelector(".submenu").classList.remove("is--open");
          }
        });
      });

      document.querySelectorAll(back_main_menu).forEach((back) => {
        back.addEventListener("click", (e) => {
          e.preventDefault();
          for (item of document.querySelectorAll(submenu)) {
            item.classList.remove("is--open");
          }
        });
      });

      document.querySelectorAll(menu_lv2).forEach((lv2) => {
        lv2.addEventListener("click", (e) => {
          const target = e.currentTarget;
          const parent = target.parentElement;
          if (
            !parent
              .querySelector(".subchildmenu")
              .classList.contains("is--open")
          ) {
            parent.querySelector(".subchildmenu").classList.add("is--open");
          } else {
            parent.querySelector(".subchildmenu").classList.remove("is--open");
          }
        });
      });

      document.querySelectorAll(back_main_menu_lv1).forEach((back) => {
        back.addEventListener("click", (e) => {
          e.preventDefault();
          for (item of document.querySelectorAll(subchildmenu)) {
            item.classList.remove("is--open");
          }
        });
      });

      document.querySelectorAll(back_main_menu_lv2).forEach((back) => {
        back.addEventListener("click", (e) => {
          e.preventDefault();
          for (item of document.querySelectorAll(subchildmenu)) {
            item.classList.remove("is--open-lv2");
          }
        });
      });

      document.querySelectorAll(back_main_menu_lv3).forEach((back) => {
        back.addEventListener("click", (e) => {
          e.preventDefault();
          for (item of document.querySelectorAll(subchildmenu)) {
            item.classList.remove("is--open-lv3");
          }
        });
      });

      document.querySelectorAll(dropdown_lv2).forEach((lv3) => {
        lv3.addEventListener("click", (e) => {
          const target = e.currentTarget;
          const parent = target.parentElement;
          if (
            !parent
              .querySelector("li .subchildmenu")
              .classList.contains("is--open-lv2")
          ) {
            parent
              .querySelector("li .subchildmenu")
              .classList.add("is--open-lv2");
          } else {
            parent
              .querySelector("li .subchildmenu")
              .classList.remove("is--open-lv2");
          }
        });
      });

      document.querySelectorAll(dropdown_lv3).forEach((lv3) => {
        lv3.addEventListener("click", (e) => {
          const target = e.currentTarget;
          const parent = target.parentElement;
          if (
            !parent
              .querySelector("li .subchildmenu")
              .classList.contains("is--open-lv3")
          ) {
            parent
              .querySelector("li .subchildmenu")
              .classList.add("is--open-lv3");
          } else {
            parent
              .querySelector("li .subchildmenu")
              .classList.remove("is--open-lv3");
          }
        });
      });
    },
  };
})();

BlsMenuActionMobile.init();

var BlsSearchShopify = (function () {
  const cachedResults = {};

  function getSearchPortal() {
    return document.querySelector("#search-form");
  }

  function mountSearchPortal() {
    const form = document.getElementById("search-form");
    if (!form || form.dataset.searchPortalMounted === "true") return;
    if (form.parentElement !== document.body) {
      document.body.appendChild(form);
    }
    form.dataset.searchPortalMounted = "true";
  }

  function isSearchOpen(form) {
    return form?.classList.contains("bls__opend-popup-header");
  }

  function closeSearch(form) {
    if (!form || !isSearchOpen(form)) return;
    form.classList.remove("bls__opend-popup-header");
    form.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("hside_opened");
    document.documentElement.classList.remove("open-search");
    const active = document.activeElement;
    if (active && form.contains(active)) {
      active.blur();
    }
  }

  function openSearch(form) {
    if (!form) return;
    form.classList.add("bls__opend-popup-header");
    form.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("hside_opened");
    document.documentElement.classList.add("open-search");
    setTimeout(function () {
      form.querySelector('input[type="search"]')?.focus();
      const predictiveSearch = form.querySelector("#predictive-search");
      if (predictiveSearch) {
        BlsLazyloadImg.activateImages(predictiveSearch);
      }
    }, 100);
  }

  function bindSearchDismiss(form) {
    if (!form || form.dataset.searchDismissBound === "true") return;

    form.querySelector("[data-search-backdrop]")?.addEventListener("click", () => {
      closeSearch(form);
    });

    const panel = form.querySelector("[data-search-panel]");
    panel?.addEventListener("click", (e) => {
      if (!isSearchOpen(form)) return;
      const content = panel.querySelector("[data-search-content]");
      if (content && !content.contains(e.target)) {
        closeSearch(form);
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape" && e.key !== "Esc") return;
      if (isSearchOpen(form)) {
        e.preventDefault();
        closeSearch(form);
      }
    });

    form.dataset.searchDismissBound = "true";
  }

  return {
    init: function () {
      mountSearchPortal();
      var predictive = document.querySelector("#predictive-search");
      if (predictive) {
        this.setupEventListeners();
      }
      const form = document.querySelector("#search-form");
      if (!form) return;
      bindSearchDismiss(form);
      document.querySelectorAll(".top-search-toggle").forEach((navToggle) => {
        navToggle.addEventListener("click", () => {
          if (!isSearchOpen(form)) {
            openSearch(form);
          } else {
            closeSearch(form);
          }
        });
      });
      document
        .querySelectorAll(".mini_search_header .button-close")
        .forEach((navToggle) => {
          navToggle.addEventListener("click", () => {
            closeSearch(form);
          });
        });
      const sf = document.querySelector(".search-full");
      if (sf) {
        const hs = sf.closest(".header_search");
        document.addEventListener("click", (e) => {
          const ehs = e.target.closest(".header_search");
          if (!ehs) {
            if (hs) {
              const ps = hs.querySelector(".popup-search");
              ps.classList.remove("popup-search-show");
            }
          } else {
            const ps = ehs.querySelector(".popup-search");
            ps.classList.add("popup-search-show");
            if (e.target && e.target.classList.contains("popup-search-show")) {
              ps.classList.remove("popup-search-show");
            }
          }
        });
      }
    },
    setupEventListeners: function () {
      this.searchPortal = getSearchPortal();
      if (!this.searchPortal) return;
      const input = this.searchPortal.querySelector('input[type="search"]');
      const form = this.searchPortal.querySelector("form.search");
      if (!input || !form) return;
      form.addEventListener("submit", this.onFormSubmit.bind(this));
      input.addEventListener(
        "input",
        this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
      input.addEventListener("focus", this.onFocus.bind(this));
      this.searchPortal.addEventListener("focusout", this.onFocusOut.bind(this));
      this.searchPortal.addEventListener("keyup", this.onKeyup.bind(this));
      this.searchPortal
        .querySelectorAll('.select_cat [data-name="product_type"] li')
        .forEach((product_type) => {
          product_type.addEventListener("click", (e) => {
            const target = e.currentTarget;
            if (target.classList.contains("active")) {
              return;
            } else {
              for (var item of this.searchPortal.querySelectorAll(
                '.select_cat [data-name="product_type"] li'
              )) {
                item.classList.remove("active");
              }
              target.classList.add("active");
              this.searchPortal
                .querySelector("#search_mini_form")
                .querySelector('[name="category"]').value =
                target.getAttribute("data-value");
              this.onChange();
            }
          });
        });
    },

    debounce: function (fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    },

    getQuery: function () {
      return (
        this.searchPortal?.querySelector('input[type="search"]')?.value.trim() ||
        ""
      );
    },

    onChange: function () {
      const searchTerm = this.getQuery();
      if (!searchTerm.length) {
        this.close(true);
        return;
      }
      this.getSearchResults(searchTerm);
    },

    onFormSubmit: function (event) {
      if (
        !this.getQuery().length ||
        this.querySelector('[aria-selected="true"] a')
      )
        event.preventDefault();
    },

    onFocus: function () {
      const searchTerm = this.getQuery();
      if (!searchTerm.length) return;
      const predictiveSearch = this.searchPortal?.querySelector(
        "#predictive-search"
      );
      if (predictiveSearch?.classList.contains("results")) {
        this.open();
      } else {
        this.getSearchResults(searchTerm);
      }
    },

    onFocusOut: function () {
      const searchPortal = this.searchPortal;
      setTimeout(() => {
        if (
          searchPortal &&
          !searchPortal.contains(document.activeElement)
        ) {
          this.close();
        }
      });
    },

    onKeyup: function (event) {
      if (!this.getQuery().length) this.close(true);

      switch (event.code) {
        case "ArrowUp":
          event.preventDefault();
          this.switchOption("up");
          break;
        case "ArrowDown":
          event.preventDefault();
          this.switchOption("down");
          break;
        case "Enter":
          this.selectOption();
          break;
      }
    },

    switchOption: function (direction) {
      if (!this.isOpen) return;
      const searchPortal = this.searchPortal;
      const moveUp = direction === "up";
      const selectedElement = searchPortal.querySelector(
        '[aria-selected="true"]'
      );
      const allElements = searchPortal.querySelectorAll(
        "#search-results-list li, .search-results-list li"
      );
      let activeElement = allElements[0];

      if (!allElements.length) return;
      if (moveUp && !selectedElement) return;

      if (!moveUp && selectedElement) {
        activeElement =
          selectedElement.nextElementSibling || allElements[0];
      } else if (moveUp) {
        activeElement =
          selectedElement.previousElementSibling ||
          allElements[allElements.length - 1];
      }

      if (activeElement === selectedElement) return;

      activeElement.setAttribute("aria-selected", true);
      if (selectedElement) selectedElement.setAttribute("aria-selected", false);
      searchPortal
        .querySelector('input[type="search"]')
        .setAttribute("aria-activedescendant", activeElement.id);
    },

    selectOption: function () {
      const selectedProduct = this.searchPortal?.querySelector(
        '[aria-selected="true"] a, [aria-selected="true"] button'
      );

      if (selectedProduct) selectedProduct.click();
    },

    getSearchResults: function (searchTerm) {
      const searchPortal = this.searchPortal || getSearchPortal();
      const queryKey = searchTerm.replace(" ", "-").toLowerCase();
      this.setLiveRegionLoadingState();
      if (cachedResults[queryKey]) {
        this.renderSearchResults(cachedResults[queryKey]);
        return;
      }
      const section_id = document.querySelector(".search_type_popup")
        ? "search-predictive-grid"
        : "search-predictive-list";
      const usePredictiveApi = !!searchPortal?.querySelector(
        "#predictive-search"
      );
      let search_url;
      if (usePredictiveApi) {
        search_url = `${routes?.predictive_search_url}?q=${encodeURIComponent(
          searchTerm
        )}&resources[options][fields]=title,tag,vendor,product_type,variants.title,variants.sku&resources[options][prefix]=last&resources[options][unavailable_products]=last&resources[type]=product&resources[limit]=6&section_id=${section_id}`;
      } else {
        search_url = `${routes.search_url}?q=${encodeURIComponent(
          searchTerm
        )}&options[prefix]=last&options[unavailable_products]=last&type=product&limit=6&section_id=${section_id}`;
      }
      fetch(`${search_url}`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
          return response.text();
        })
        .then((text) => {
          const sectionNode = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#shopify-section-" + section_id);
          if (!sectionNode) {
            this.setLiveRegionResults();
            return;
          }
          const resultsMarkup = sectionNode.innerHTML;
          cachedResults[queryKey] = resultsMarkup;
          this.renderSearchResults(resultsMarkup);
          BlsColorSwatchesShopify.init();
          BlsLazyloadImg.activateImages(
            this.searchPortal?.querySelector("#predictive-search")
          );
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    },

    setLiveRegionLoadingState: function () {
      this.searchPortal
        ?.querySelector("#search_mini_form")
        ?.classList.add("loading");
      this.searchPortal
        ?.querySelector("#predictive-search")
        ?.classList.add("loading");
    },

    setLiveRegionResults: function () {
      this.searchPortal
        ?.querySelector("#search_mini_form")
        ?.classList.remove("loading");
      this.searchPortal
        ?.querySelector("#predictive-search")
        ?.classList.remove("loading");
    },

    renderSearchResults: function (resultsMarkup) {
      const predictiveContainer = this.searchPortal?.querySelector(
        "[data-predictive-search]"
      );
      const predictiveSearch = this.searchPortal?.querySelector(
        "#predictive-search"
      );
      if (!predictiveContainer || !predictiveSearch) return;
      predictiveContainer.innerHTML =
        resultsMarkup +
        '<div class="predictive-search__loading-state mt-15"><div class="loading-search"></div></div>';
      predictiveSearch.classList.add("results");
      const quick_search = this.searchPortal.querySelector("#quick-search");
      if (quick_search) {
        quick_search.classList.add("d-none");
      }
      this.setLiveRegionResults();
      this.open();
      BlsLazyloadImg.activateImages(predictiveSearch);
    },

    open: function () {
      this.searchPortal
        ?.querySelector('input[type="search"]')
        ?.setAttribute("aria-expanded", true);
      this.isOpen = true;
    },

    close: function (clearSearchTerm = false) {
      const searchInput = this.searchPortal?.querySelector(
        'input[type="search"]'
      );
      const predictiveSearch = this.searchPortal?.querySelector(
        "#predictive-search"
      );
      if (clearSearchTerm && searchInput) {
        searchInput.value = "";
        predictiveSearch?.classList.remove("results");
        const quick_search = this.searchPortal?.querySelector("#quick-search");
        if (quick_search) {
          quick_search.classList.remove("d-none");
        }
      }
      const selected = this.searchPortal?.querySelector(
        '[aria-selected="true"]'
      );
      if (selected) selected.setAttribute("aria-selected", false);
      searchInput?.setAttribute("aria-activedescendant", "");
      searchInput?.setAttribute("aria-expanded", false);
      this.resultsMaxHeight = false;
      this.searchPortal
        ?.querySelector("[data-predictive-search]")
        ?.removeAttribute("style");
      this.isOpen = false;
    },
  };
})();
BlsSearchShopify.init();

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}
class VideoYoutube extends HTMLElement {
  constructor() {
    super();
    const thumb = this.closest(".bls__video-thumb");
    if (thumb) {
      thumb.querySelector(".bls__thmbnail-video").classList.add("d-none");
    }
  }
}
customElements.define("video-youtube", VideoYoutube);

class PageBrands extends HTMLElement {
  constructor() {
    super();
    this.getAllBrands();
    this.loadContent();
    this.brandsCode = this.querySelector("#brandsCode");
    const navigation = document.querySelector("#brandsCode");
    this.brandsCode.querySelectorAll(".brand-filter").forEach((brands) => {
      brands.addEventListener("click", this.actionFilter.bind(this));
    });
    this.brandGroup = this.querySelectorAll(".brands-group").forEach(
      (element) => {
        const letter = element?.dataset.code;
        if (element.querySelector(".brand") == null) {
          element.closest(".brands-group").classList.add("d-none");
          navigation
            .querySelector(`[data-code="${letter}"]`)
            .classList.add("disable");
        } else {
          element.closest(".brands-group").classList.remove("d-none");
          element.closest(".brands-group").classList.add("brands-active");
          navigation
            .querySelector(`[data-code="${letter}"]`)
            .classList.remove("disable");
          navigation
            .querySelector(`[data-code="${letter}"]`)
            .classList.add("has-class");
        }
      }
    );
  }

  getAllBrands() {
    let brandGroup, brandLink;
    const wrapper = document.querySelector("#brandsWrap");
    const dataBrands = JSON.parse(
      this.querySelector(".brandsVendor").textContent
    );
    var listBrands = dataBrands.map((brand) => {
      brandLink = `<a href="/collections/vendors?q=${brand.title}">${brand.title}</a>`;
      const letter = brand.letter;
      return `<li class="brand" data-code="${letter}">${brandLink}</li>`;
    });
    const listCheck = newParser.parseFromString(listBrands, "text/html");
    listCheck.querySelectorAll("li").forEach((item) => {
      const letter = item.dataset.code;
      if (
        letter == "1" ||
        letter == "2" ||
        letter == "3" ||
        letter == "4" ||
        letter == "5" ||
        letter == "6" ||
        letter == "7" ||
        letter == "8" ||
        letter == "9" ||
        letter == "0"
      ) {
        brandGroup = wrapper.querySelector('.brands-group[data-code="#"] ul');
      } else {
        brandGroup = wrapper.querySelector(
          `.brands-group[data-code="${letter}"] ul`
        );
      }
      brandGroup.append(item);
    });
  }

  parseBrandList() {
    const navigation = document.querySelector("#brandsCode");
    document.querySelectorAll(".brands-group").forEach((element) => {
      const letter = element?.dataset.code;

      if (
        document.querySelector(".brands-group-list", element).children[0]
          .length > 0
      ) {
        navigation
          .querySelector(`[data-code="${letter}"]`)
          .removeClass("disable")
          .addClass("has-letter");
      }
    });
  }

  loadContent() {
    window.addEventListener("load", () => {
      const collectionLinksElement = document.querySelector(".wrapper-brands");
      const collectionLinksList = [
        ...collectionLinksElement.querySelectorAll("ul li"),
      ];
      const firstLink = collectionLinksList[0];
      const lastLink = collectionLinksList.pop();

      collectionLinksElement.classList.add("initialized");

      const scrollToLastObserver = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            collectionLinksElement.classList.add("disable-last");
          } else {
            collectionLinksElement.classList.remove("disable-last");
          }
        },
        {
          threshold: 0.6,
        }
      );

      const scrollToFirstObserver = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            collectionLinksElement.classList.add("disable-first");
          } else {
            collectionLinksElement.classList.remove("disable-first");
          }
        },
        {
          threshold: 0.6,
        }
      );

      scrollToLastObserver.observe(lastLink);
      scrollToFirstObserver.observe(firstLink);
    });
  }

  actionFilter(event) {
    event.preventDefault();
    this.querySelectorAll(".brand-filter").forEach((element) => {
      element.classList.remove("is-active");
    });
    event.target.closest("li").classList.add("is-active");

    var code = event.target.dataset.href;
    this.querySelectorAll(".brands-group").forEach((brands) => {
      brands.classList.remove("is-active");
    });

    if (code != undefined || code != null) {
      this.querySelector("#brandsWrap").classList.remove("active-all");
      this.querySelector(`#brandsWrap [data-code="${code}"]`).classList.add(
        "is-active"
      );
    } else {
      this.querySelector("#brandsWrap").classList.add("active-all");
    }
  }
}
customElements.define("page-brands", PageBrands);

var BlsPortfolioPage = (function () {
  return {
    init: function () {
      this.renderLayout();
    },
    renderLayout: function () {
      const portfolio = document.querySelector(".bls__blog-articles-portfolio");
      if (portfolio) {
        new Masonry(portfolio);
      }
    },
  };
})();
BlsPortfolioPage.init();

var BlsLoadMoreCarrer = (function () {
  return {
    init: function () {
      this.loadMore();
    },
    loadMore: function () {
      const loadPage = document.querySelector(".load-more-page");
      if (loadPage) {
        const main = document.querySelector(".bls-carrer__content");
        var limitItemShow = Number(main.dataset.limit),
          lenghtCa = document.querySelectorAll(".bls-carrer__item").length;
        if (lenghtCa > limitItemShow) {
          const allCareer = document.querySelectorAll(".bls-carrer__item");
          const defaultPercent = document.querySelector(
            ".carrer-action .load-more-percent"
          );
          defaultPercent.style.width =
            (limitItemShow * 100) / allCareer.length + "%";
          var lineCare = Array.from(
            document.querySelectorAll(".bls-carrer__item")
          );
          lineCare.forEach((element, index) => {
            if (index > limitItemShow - 1) {
              const item = lineCare[index];
              if (item.classList.contains("load-carrer")) {
                return;
              }
              item.setAttribute("data-hide", true);
            }
          });
          document
            .querySelector(".load-carrer")
            .addEventListener("click", (e) => {
              e.preventDefault();
              const target = e.currentTarget;
              const parent = target.parentElement;
              let itemCarrer = [
                ...parent
                  .closest(".bls-carrer__content")
                  .querySelectorAll(".bls-carrer__item"),
              ];
              for (
                var i = limitItemShow;
                i < limitItemShow + limitItemShow;
                i++
              ) {
                if (itemCarrer[i]) {
                  itemCarrer[i].setAttribute("data-hide", false);
                }
              }
              limitItemShow += limitItemShow;
              const f = [
                ...parent
                  .closest(".bls-carrer__content")
                  .querySelectorAll('.bls-carrer__item[data-hide="false"]'),
              ];
              const contentLimit = parent.querySelector(".limit-carrer");
              contentLimit.innerHTML = f.length;
              const classPercent = parent.querySelector(".load-more-percent");
              var percent;
              percent = (f.length * 100) / itemCarrer.length;
              if (limitItemShow >= lenghtCa) {
                document.querySelector(".load-carrer").style.display = "none";
                percent = 100;
              }
              classPercent.style.width = percent + "%";
            });
        }
      }
    },
  };
})();

BlsLoadMoreCarrer.init();

document.addEventListener("shopify:section:load", function (event) {
  var id = event.detail.sectionId;
  var section =
    (event.target.matches && event.target.matches("[data-id='" + id + "']")) ? event.target :
      (event.target.matches && event.target.matches("[data-section-id='" + id + "']")) ? event.target :
        event.target.querySelector("[data-id='" + id + "']") ||
        event.target.querySelector("[data-section-id='" + id + "']") ||
        document.querySelector("[data-id='" + id + "']") ||
        document.querySelector("[data-section-id='" + id + "']");
  if (section) {
    var element = section.querySelector(".bls__swiper");
    var customSlide = section.querySelector(".slideshow-custom");
    var testimonial = section.querySelector(".bls__testimonial");
    var portfolio = section.querySelector(".bls__blog-articles-portfolio");
    var carrer = section.querySelector(".bls-carrer__content");
    if (portfolio) {
      BlsPortfolioPage.init();
    }
    if (customSlide) {
      BlsCustomSlideShow.init();
    }
    if (element) {
      BlsSettingsSwiper.BlsCarousel(element);
    }
    if (testimonial) {
      BlsSettingsSwiperTestimonial.init();
    }
    if (carrer) {
      BlsLoadMoreCarrer.init();
    }
  }
  if (id) {
    BlsLazyloadImg.init();
  }
});

// Clean up Swiper instances when a section is unloaded in the Theme Editor
document.addEventListener('shopify:section:unload', function (event) {
  var id = event.detail.sectionId;
  if (!id) return;
  var selector = "#bls__swiper-" + id;
  var el = document.querySelector(selector);
  if (el && el.swiper) {
    try { el.swiper.destroy(true, true); } catch (e) { }
  }
  if (window.blsSwiperInstances && window.blsSwiperInstances[id]) {
    try { window.blsSwiperInstances[id].destroy(true, true); } catch (e) { }
    delete window.blsSwiperInstances[id];
  }
});

var BlsFormWizard = (function () {
  return {
    init: function () {
      this.setupEventListeners();
    },

    setupEventListeners: function (value) {
      const $$ = document.querySelectorAll.bind(document);
      $$(".bls-js-form-wizard").forEach((el) => {
        const tab_item = el.querySelectorAll(".steps-item");
        if (tab_item.length != 0) {
          tab_item.forEach((e) => {
            e.addEventListener("click", function () {
              if (!this.classList.contains("active")) {
                el.querySelectorAll(".steps-item").forEach((element) => {
                  element.classList.remove("active");
                });
                this.classList.add("active");
                const tabId = this.dataset.id;
                el.querySelectorAll(".bls__form-wizard-item").forEach(
                  (element) => {
                    if (element.id === tabId) {
                      if (!element.classList.contains("active")) {
                        el.querySelectorAll(".bls__form-wizard-item").forEach(
                          (elm) => {
                            elm.classList.remove("active");
                          }
                        );
                        element.classList.add("active");
                      }
                    }
                  }
                );
              }
            });
          });
        } else {
          const tabId = value;
          el.querySelectorAll(".bls__form-wizard-item").forEach((element) => {
            if (element.id === tabId) {
              if (!element.classList.contains("active")) {
                el.querySelectorAll(".bls__form-wizard-item").forEach((elm) => {
                  elm.classList.remove("active");
                });
                element.classList.add("active");
              }
            }
          });
        }
      });
    },
  };
})();
BlsFormWizard.init();

// BlsCustomClass = (function () {
//   return {
//     init: function () {
//       document.querySelectorAll('.header-absolute').forEach(items => {
//         if (items) {
//           const wrapper = items.closest('.bls-wrapper');
//           const header = wrapper.querySelector('header');
//           header.classList.add('h-transparent');
//           header.querySelector('.js-header').classList.add('header-transparent');
//           header.querySelector('.header-middle').classList.add('transparent');
//         }
//       })
//     }
//   };
// })();

// BlsCustomClass.init();

// const GorderPopup = (function () {
//   return {
//     init: function () {
//       const pathname = window.location.pathname;
//       if (pathname.includes("pages/gorde")) {
//         let content_html = document.querySelector(".contact-left-support");
//         if (content_html) {
//           setTimeout(() => {
//             var gordepopup = EasyDialogBox.create(
//               "gordepopup",
//               "dlg dlg-disable-footer dlg-disable-drag dlg-disable-heading",
//               null,
//               content_html.innerHTML
//             );
//             gordepopup.onClose = gordepopup.destroy;
//             gordepopup.show(300);
//           }, 15000);
//         }
//       }
//     },
//   };
// })();

// GorderPopup.init();
